import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  GraphQLDate: any;
  Upload: any;
};

export type AcquireFreeScenarioResult = {
  __typename?: 'AcquireFreeScenarioResult';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type Admin = {
  __typename?: 'Admin';
  _id: Scalars['ID'];
  email: Scalars['String'];
};

export type AnchorImageInput = {
  hiddenMessage: Scalars['String'];
  name: Scalars['String'];
  physicalWidth: Scalars['Float'];
  url: Scalars['String'];
};

export type AnchorImages = {
  __typename?: 'AnchorImages';
  hiddenMessage: Scalars['String'];
  name: Scalars['String'];
  physicalWidth: Scalars['Float'];
  url: Scalars['String'];
};

export type ApplyDiscountResult = {
  __typename?: 'ApplyDiscountResult';
  discount?: Maybe<Discount>;
  error?: Maybe<Scalars['String']>;
};

export type AugmentedReality = {
  __typename?: 'AugmentedReality';
  anchorImages: Array<AnchorImages>;
  type: SubmitBlockType;
};

export type AuthenticationInfo = ErrorAuthenticationInfo | SuccessAuthenticationInfo;

export type AutoPlayingSound = {
  __typename?: 'AutoPlayingSound';
  type: SubmitBlockType;
};

export type BackpackItem = {
  __typename?: 'BackpackItem';
  _id: Scalars['ID'];
  blockingScenarioLocationId?: Maybe<Scalars['ID']>;
  description: Scalars['String'];
  imageKey: Scalars['String'];
  scenarioId: Scalars['ID'];
  state: BackpackItemState;
  title: Scalars['String'];
};

export type BackpackItemInput = {
  blockingScenarioLocationId?: InputMaybe<Scalars['ID']>;
  description: Scalars['String'];
  imageKey: Scalars['String'];
  title: Scalars['String'];
};

export type BackpackItemResult = {
  __typename?: 'BackpackItemResult';
  backpackItem?: Maybe<BackpackItem>;
  errors?: Maybe<Array<Scalars['String']>>;
};

export enum BackpackItemState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export type ButtonBlock = {
  __typename?: 'ButtonBlock';
  label: Scalars['String'];
  type: SubmitBlockType;
};

export type CameraLayer = {
  __typename?: 'CameraLayer';
  layerImageUrl: Scalars['String'];
  type: SubmitBlockType;
};

export type Carousel = {
  __typename?: 'Carousel';
  answerImageUrl: Scalars['String'];
  imagesSize: Scalars['Int'];
  type: SubmitBlockType;
  wrongImageUrls: Array<Scalars['String']>;
};

export type Cell = {
  __typename?: 'Cell';
  column: Scalars['Int'];
  row: Scalars['Int'];
};

export type CellInput = {
  column: Scalars['Int'];
  row: Scalars['Int'];
};

export type CesarCode = {
  __typename?: 'CesarCode';
  plainText: Scalars['String'];
  stringCode: Scalars['String'];
  type: SubmitBlockType;
};

export type City = {
  __typename?: 'City';
  _id: Scalars['ID'];
  description: Scalars['String'];
  imageKey: Scalars['String'];
  name: Scalars['String'];
  scenarios: Array<Scenario>;
  slug: Scalars['String'];
};

export type CityScenariosInfo = {
  __typename?: 'CityScenariosInfo';
  _id: Scalars['ID'];
  imageKey: Scalars['String'];
  name: Scalars['String'];
  scenarios: Array<Scenario>;
};

export type Collection = {
  __typename?: 'Collection';
  _id: Scalars['ID'];
  areaRadius?: Maybe<Scalars['Int']>;
  image: Image;
  imageKey: Scalars['String'];
  items: Array<CollectionItem>;
  name: Scalars['String'];
  numberOfFoundItems: Scalars['Int'];
  numberOfItems: Scalars['Int'];
  state: CollectionState;
  type: CollectionType;
};

export type CollectionItem = {
  __typename?: 'CollectionItem';
  _id: Scalars['ID'];
  fuzzyLocation?: Maybe<Point>;
  image: Image;
  imageKey: Scalars['String'];
  location: Point;
  name: Scalars['String'];
  state: CollectionState;
  wasFound: Scalars['Boolean'];
};

export type CollectionItemResult = {
  __typename?: 'CollectionItemResult';
  collectionItem?: Maybe<CollectionItem>;
  errors?: Maybe<Array<Scalars['String']>>;
};

export enum CollectionItemState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export enum CollectionState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export enum CollectionType {
  Hidden = 'Hidden',
  RevealedArea = 'RevealedArea',
  RevealedLocation = 'RevealedLocation'
}

export type ColorLetter = {
  __typename?: 'ColorLetter';
  color: Scalars['String'];
  letter: Scalars['String'];
};

export type ColorLetterInput = {
  color: Scalars['String'];
  letter: Scalars['String'];
};

export type ColorLetters = {
  __typename?: 'ColorLetters';
  colorLetters: Array<ColorLetter>;
  type: SubmitBlockType;
};

export type CombinationPadlock = {
  __typename?: 'CombinationPadlock';
  type: SubmitBlockType;
};

export type CommuteLines = {
  __typename?: 'CommuteLines';
  metroLines: Array<MetroLine>;
  rerLines: Array<RerLine>;
};

export type CommuteLinesInput = {
  metroLines: Array<MetroLine>;
  rerLines: Array<RerLine>;
};

export type CommuteStation = {
  __typename?: 'CommuteStation';
  commuteLines: CommuteLines;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CommuteStationInput = {
  commuteLines: CommuteLinesInput;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type ContentBlock = EquationsBlock | ImageBlock | ParagraphBlock | SubtitleBlock | TitleBlock;

export type ContentBlockInput = {
  equations?: InputMaybe<Array<Scalars['String']>>;
  imageKey?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  type: ContentBlockType;
};

export enum ContentBlockType {
  Equations = 'Equations',
  Image = 'Image',
  Paragraph = 'Paragraph',
  Subtitle = 'Subtitle',
  Title = 'Title'
}

export type ContentTemplate = {
  __typename?: 'ContentTemplate';
  blocks: Array<ContentBlock>;
  type: PuzzleType;
};

export type CreateCollectionItemInput = {
  imageInput: ImageInput;
  imageKey: Scalars['String'];
  location: PointInput;
  name: Scalars['String'];
};

export type CreatePuzzleInput = {
  blockingPuzzleIds: Array<Scalars['String']>;
  expectedAnswer?: InputMaybe<Scalars['String']>;
  hints: Array<Scalars['String']>;
  scenarioLocationId: Scalars['ID'];
  scoreTiers: Array<Scalars['String']>;
  submitBlock: SubmitBlockInput;
  template: PuzzleTemplateInput;
  title: Scalars['String'];
};

export type DefaultScoreTier = {
  __typename?: 'DefaultScoreTier';
  pointsReward: Scalars['Int'];
};

export type Digicode = {
  __typename?: 'Digicode';
  type: SubmitBlockType;
};

export type Discount = {
  __typename?: 'Discount';
  _id: Scalars['ID'];
  amount: Scalars['Int'];
  code: Scalars['String'];
  restrictedUserIds: Array<Scalars['String']>;
  state: DiscountState;
};

export type DiscountAuthorizationResult = {
  __typename?: 'DiscountAuthorizationResult';
  discount?: Maybe<Discount>;
  error?: Maybe<Scalars['String']>;
  isAuthorized: Scalars['Boolean'];
};

export enum DiscountState {
  Active = 'Active',
  Archived = 'Archived'
}

export type EquationsBlock = {
  __typename?: 'EquationsBlock';
  equations: Array<Scalars['String']>;
  type: ContentBlockType;
};

export type ErrorAuthenticationInfo = {
  __typename?: 'ErrorAuthenticationInfo';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ForceValidatePuzzleResult = {
  __typename?: 'ForceValidatePuzzleResult';
  nextGamePuzzle?: Maybe<GamePuzzle>;
};

export type FourDolphins = {
  __typename?: 'FourDolphins';
  type: SubmitBlockType;
};

export type FunFact = {
  __typename?: 'FunFact';
  imageKey?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type FunFactInput = {
  imageKey?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
};

export type GalerieColbert = {
  __typename?: 'GalerieColbert';
  type: SubmitBlockType;
};

export type Game = {
  __typename?: 'Game';
  _id: Scalars['ID'];
  completedAt?: Maybe<Scalars['GraphQLDate']>;
  createdAt: Scalars['GraphQLDate'];
  date: Scalars['String'];
  deviceIds: Array<Scalars['ID']>;
  gameLocations: Array<GameLocation>;
  hasFinishedEndQuiz: Scalars['Boolean'];
  isInDemoMode: Scalars['Boolean'];
  joinCode: Scalars['String'];
  progressRatio: Scalars['Float'];
  scenario: Scenario;
  score: Scalars['Int'];
  startedAt?: Maybe<Scalars['GraphQLDate']>;
  state: GameState;
  totalPotentialScore: Scalars['Int'];
  transaction?: Maybe<Transaction>;
  user: User;
};

export type GameLocation = {
  __typename?: 'GameLocation';
  _id: Scalars['ID'];
  completedAt?: Maybe<Scalars['GraphQLDate']>;
  gamePuzzles: Array<GamePuzzle>;
  nextGamePuzzleId?: Maybe<Scalars['ID']>;
  progressRatio: Scalars['Float'];
  scenarioLocation: ScenarioLocation;
  startedAt?: Maybe<Scalars['GraphQLDate']>;
  state: GameLocationState;
};

export enum GameLocationState {
  Archived = 'Archived',
  Completed = 'Completed',
  Locked = 'Locked',
  Unlocked = 'Unlocked'
}

export type GamePuzzle = {
  __typename?: 'GamePuzzle';
  _id: Scalars['ID'];
  completedAt?: Maybe<Scalars['GraphQLDate']>;
  guesses: Array<Maybe<Scalars['String']>>;
  numberOfUsedHints: Scalars['Int'];
  puzzle: Puzzle;
  startedAt?: Maybe<Scalars['GraphQLDate']>;
  state: GamePuzzleState;
};

export enum GamePuzzleState {
  Archived = 'Archived',
  Completed = 'Completed',
  Locked = 'Locked',
  Unlocked = 'Unlocked'
}

export enum GameState {
  Completed = 'Completed',
  Created = 'Created',
  Started = 'Started'
}

export type HideAndSeek = {
  __typename?: 'HideAndSeek';
  hiddenImageKey: Scalars['String'];
  hidingImageKey: Scalars['String'];
  type: SubmitBlockType;
};

export type HotAndColdTemplate = {
  __typename?: 'HotAndColdTemplate';
  blocks: Array<ContentBlock>;
  targetLocation: Point;
  type: PuzzleType;
};

export type Image = {
  __typename?: 'Image';
  aspectRatio: Scalars['Float'];
  caption?: Maybe<Scalars['String']>;
  thumbhash: Scalars['String'];
  url: Scalars['String'];
};

export type ImageAreas = {
  __typename?: 'ImageAreas';
  answerCells: Array<Cell>;
  imageKey: Scalars['String'];
  numberOfColumns: Scalars['Int'];
  numberOfRows: Scalars['Int'];
  type: SubmitBlockType;
};

export type ImageBlock = {
  __typename?: 'ImageBlock';
  imageKey: Scalars['String'];
  type: ContentBlockType;
};

export type ImageInput = {
  aspectRatio?: InputMaybe<Scalars['Float']>;
  caption?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['Upload']>;
  thumbhash?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type ImageItemInput = {
  imageKey: Scalars['String'];
  isCorrect?: InputMaybe<Scalars['Boolean']>;
  isInitiallyRevealed?: InputMaybe<Scalars['Boolean']>;
  position?: InputMaybe<Scalars['Int']>;
};

export type ImageTranslation = {
  __typename?: 'ImageTranslation';
  _id: Scalars['ID'];
  createdAt: Scalars['GraphQLDate'];
  english: NullableImage;
  french: Image;
  isGlobal: Scalars['Boolean'];
  key: Scalars['String'];
  sectionId: Scalars['String'];
  state: ImageTranslationState;
  updatedAt: Scalars['GraphQLDate'];
};

export type ImageTranslationCreateInput = {
  english: ImageInput;
  french: ImageInput;
  isGlobal: Scalars['Boolean'];
  key: Scalars['String'];
  sectionId: Scalars['String'];
};

export type ImageTranslationCreateType = {
  __typename?: 'ImageTranslationCreateType';
  english: NullableImage;
  french: Image;
  isGlobal: Scalars['Boolean'];
  key: Scalars['String'];
  sectionId: Scalars['String'];
};

export enum ImageTranslationState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export type ImageTranslationUpdateInput = {
  _id: Scalars['String'];
  english: ImageInput;
  french: ImageInput;
  isGlobal: Scalars['Boolean'];
  key: Scalars['String'];
  sectionId: Scalars['String'];
};

export type ImageTranslationUpdateResult = {
  __typename?: 'ImageTranslationUpdateResult';
  errors: Array<Scalars['String']>;
  imageTranslations: Array<ImageTranslation>;
};

export type ImageTranslationUpdateType = {
  __typename?: 'ImageTranslationUpdateType';
  _id: Scalars['String'];
  english: NullableImage;
  french: Image;
  isGlobal: Scalars['Boolean'];
  key: Scalars['String'];
  sectionId: Scalars['String'];
};

export type ImagesOrdering = {
  __typename?: 'ImagesOrdering';
  imageItems: Array<ImagesOrderingItem>;
  type: SubmitBlockType;
};

export type ImagesOrderingItem = {
  __typename?: 'ImagesOrderingItem';
  imageKey: Scalars['String'];
  isInitiallyRevealed: Scalars['Boolean'];
  position: Scalars['Int'];
};

export type ImagesSelection = {
  __typename?: 'ImagesSelection';
  imageItems: Array<ImagesSelectionItem>;
  type: SubmitBlockType;
};

export type ImagesSelectionItem = {
  __typename?: 'ImagesSelectionItem';
  imageKey: Scalars['String'];
  isCorrect: Scalars['Boolean'];
};

export type ImagesSorting = {
  __typename?: 'ImagesSorting';
  imageItems: Array<ImagesSortingItem>;
  type: SubmitBlockType;
};

export type ImagesSortingItem = {
  __typename?: 'ImagesSortingItem';
  imageKey: Scalars['String'];
  position: Scalars['Int'];
};

export type InitScenarioPurchaseResult = {
  __typename?: 'InitScenarioPurchaseResult';
  customerEphemeralKeySecret: Scalars['ID'];
  customerId: Scalars['ID'];
  paymentIntentClientSecret: Scalars['ID'];
};

export type InputBlock = {
  __typename?: 'InputBlock';
  inputLabel?: Maybe<Scalars['String']>;
  keyboardType?: Maybe<KeyboardType>;
  placeholder?: Maybe<Scalars['String']>;
  type: SubmitBlockType;
};

export type InsertTransactionResult = {
  __typename?: 'InsertTransactionResult';
  game?: Maybe<Game>;
};

export type JoinGameResult = {
  __typename?: 'JoinGameResult';
  errors?: Maybe<Array<Scalars['String']>>;
  game?: Maybe<Game>;
  success: Scalars['Boolean'];
};

export enum KeyboardType {
  Default = 'Default',
  NumberPad = 'NumberPad'
}

export type Landmark = {
  __typename?: 'Landmark';
  _id: Scalars['ID'];
  blocks: Array<ContentBlock>;
  imageKey: Scalars['String'];
  location: Point;
  scenarioId: Scalars['ID'];
  state: LandmarkState;
  title: Scalars['String'];
};

export type LandmarkIdAndLocationInput = {
  landmarkId: Scalars['ID'];
  location: PointInput;
};

export type LandmarkInput = {
  blocks: Array<ContentBlockInput>;
  imageKey: Scalars['String'];
  location: PointInput;
  scenarioId: Scalars['ID'];
  title: Scalars['String'];
};

export type LandmarkResult = {
  __typename?: 'LandmarkResult';
  errors?: Maybe<Array<Scalars['String']>>;
  landmark?: Maybe<Landmark>;
};

export enum LandmarkState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export type LandmarkUpdateInput = {
  blocks?: InputMaybe<Array<ContentBlockInput>>;
  imageKey: Scalars['String'];
  location?: InputMaybe<PointInput>;
  title?: InputMaybe<Scalars['String']>;
};

export type LandmarksResult = {
  __typename?: 'LandmarksResult';
  errors?: Maybe<Array<Scalars['String']>>;
  landmarks?: Maybe<Array<Landmark>>;
};

export enum Language {
  English = 'English',
  French = 'French'
}

export type LetterNote = {
  __typename?: 'LetterNote';
  letter: Scalars['String'];
  noteIndex: Scalars['Int'];
};

export type LetterNoteInput = {
  letter: Scalars['String'];
  noteIndex: Scalars['Int'];
};

export type LightBulbs = {
  __typename?: 'LightBulbs';
  imageOffUrl: Scalars['String'];
  imageOnUrl: Scalars['String'];
  type: SubmitBlockType;
};

export enum MetroLine {
  Metro1 = 'Metro1',
  Metro2 = 'Metro2',
  Metro3 = 'Metro3',
  Metro3Bis = 'Metro3Bis',
  Metro4 = 'Metro4',
  Metro5 = 'Metro5',
  Metro6 = 'Metro6',
  Metro7 = 'Metro7',
  Metro7Bis = 'Metro7Bis',
  Metro8 = 'Metro8',
  Metro9 = 'Metro9',
  Metro10 = 'Metro10',
  Metro11 = 'Metro11',
  Metro12 = 'Metro12',
  Metro13 = 'Metro13',
  Metro14 = 'Metro14',
  Metro15 = 'Metro15',
  Metro16 = 'Metro16',
  Metro17 = 'Metro17',
  Metro18 = 'Metro18'
}

export type MorseCode = {
  __typename?: 'MorseCode';
  code: Scalars['String'];
  type: SubmitBlockType;
};

export type MultiSelect = {
  __typename?: 'MultiSelect';
  answerIndices: Array<Scalars['Int']>;
  optionLabels: Array<Scalars['String']>;
  type: SubmitBlockType;
};

export type MusicSheet = {
  __typename?: 'MusicSheet';
  sequencesToGuess: Array<Array<LetterNote>>;
  type: SubmitBlockType;
};

export type Mutation = {
  __typename?: 'Mutation';
  acquireDemoScenario: Game;
  acquireFreeScenario: Scalars['Boolean'];
  applyDiscount: ApplyDiscountResult;
  archiveBackpackItem: BackpackItemResult;
  archiveLandmark: LandmarkResult;
  archivePuzzle: PuzzleResult;
  archiveScenarioLocation: ScenarioLocationResult;
  createBackpackItem: BackpackItemResult;
  createCollectionItem: CollectionItemResult;
  createGame: Transaction;
  createLandmark: LandmarkResult;
  createPuzzle: PuzzleResult;
  createScenarioLocation: ScenarioLocationResult;
  forceValidatePuzzle: ForceValidatePuzzleResult;
  incrementNumberOfUsedHints: GamePuzzle;
  initScenarioPurchase: InitScenarioPurchaseResult;
  insertTransaction: Transaction;
  joinGame: JoinGameResult;
  loginAdmin: AuthenticationInfo;
  reviewGame: Review;
  startGame: Game;
  submitFoundCollectionItem: Array<CollectionItem>;
  submitPuzzleAnswer: PuzzleAnswerResult;
  updateBackpackItem: BackpackItemResult;
  updateGamePuzzleState: Game;
  updateImageTranslations: ImageTranslationUpdateResult;
  updateLandmark: LandmarkResult;
  updateLandmarksLocations: LandmarksResult;
  updatePersonalInfoMutation: User;
  updatePuzzle: PuzzleResult;
  updateScenario: ScenarioResult;
  updateScenarioLocation: ScenarioLocationResult;
  updateTranslations: Array<Translation>;
  validateEndQuiz: Game;
  verifyToken: TokenVerificationResult;
};


export type MutationAcquireDemoScenarioArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  language: Language;
  lastName: Scalars['String'];
  scenarioId: Scalars['ID'];
};


export type MutationAcquireFreeScenarioArgs = {
  discountId?: InputMaybe<Scalars['ID']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  gameId?: InputMaybe<Scalars['ID']>;
  language: Language;
  lastName: Scalars['String'];
  scenarioId: Scalars['ID'];
};


export type MutationApplyDiscountArgs = {
  code: Scalars['String'];
  email: Scalars['String'];
};


export type MutationArchiveBackpackItemArgs = {
  backpackItemId: Scalars['ID'];
};


export type MutationArchiveLandmarkArgs = {
  landmarkId: Scalars['ID'];
};


export type MutationArchivePuzzleArgs = {
  puzzleId: Scalars['ID'];
};


export type MutationArchiveScenarioLocationArgs = {
  scenarioLocationId: Scalars['ID'];
};


export type MutationCreateBackpackItemArgs = {
  backpackItemInput: BackpackItemInput;
  scenarioId: Scalars['ID'];
};


export type MutationCreateCollectionItemArgs = {
  collectionId: Scalars['ID'];
  collectionItemInput: CreateCollectionItemInput;
};


export type MutationCreateGameArgs = {
  discountId?: InputMaybe<Scalars['ID']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  language: Language;
  lastName: Scalars['String'];
  scenarioId: Scalars['ID'];
};


export type MutationCreateLandmarkArgs = {
  landmarkInput: LandmarkInput;
};


export type MutationCreatePuzzleArgs = {
  puzzleInput: CreatePuzzleInput;
};


export type MutationCreateScenarioLocationArgs = {
  scenarioId: Scalars['ID'];
  scenarioLocationInput: ScenarioLocationInput;
};


export type MutationForceValidatePuzzleArgs = {
  gamePuzzleId: Scalars['ID'];
};


export type MutationIncrementNumberOfUsedHintsArgs = {
  gamePuzzleId: Scalars['ID'];
  hintIndex: Scalars['Int'];
};


export type MutationInitScenarioPurchaseArgs = {
  discountId?: InputMaybe<Scalars['ID']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  gameId?: InputMaybe<Scalars['ID']>;
  language: Language;
  lastName: Scalars['String'];
  scenarioId: Scalars['ID'];
};


export type MutationInsertTransactionArgs = {
  appUserId: Scalars['ID'];
  gameId?: InputMaybe<Scalars['ID']>;
  scenarioId: Scalars['ID'];
  userInfo: UserInfo;
};


export type MutationJoinGameArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type MutationLoginAdminArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationReviewGameArgs = {
  comment?: InputMaybe<Scalars['String']>;
  gameId: Scalars['ID'];
  rating: Scalars['Int'];
};


export type MutationStartGameArgs = {
  gameId: Scalars['ID'];
};


export type MutationSubmitFoundCollectionItemArgs = {
  collectionId: Scalars['ID'];
  userLocation: PointInput;
};


export type MutationSubmitPuzzleAnswerArgs = {
  gamePuzzleId: Scalars['ID'];
  guess?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateBackpackItemArgs = {
  backpackItemId: Scalars['ID'];
  updateInput: BackpackItemInput;
};


export type MutationUpdateGamePuzzleStateArgs = {
  gamePuzzleId: Scalars['ID'];
  state: GamePuzzleState;
};


export type MutationUpdateImageTranslationsArgs = {
  archivedImageTranslationIds: Array<Scalars['ID']>;
  newImageTranslations: Array<ImageTranslationCreateInput>;
  updatedImageTranslations: Array<ImageTranslationUpdateInput>;
};


export type MutationUpdateLandmarkArgs = {
  landmarkId: Scalars['ID'];
  updateInput: LandmarkUpdateInput;
};


export type MutationUpdateLandmarksLocationsArgs = {
  landmarkIdsAndLocations: Array<LandmarkIdAndLocationInput>;
};


export type MutationUpdatePersonalInfoMutationArgs = {
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
};


export type MutationUpdatePuzzleArgs = {
  puzzleId: Scalars['ID'];
  updateInput: PuzzleUpdateInput;
};


export type MutationUpdateScenarioArgs = {
  scenarioId: Scalars['ID'];
  scenarioUpdateInput?: InputMaybe<ScenarioUpdateInput>;
};


export type MutationUpdateScenarioLocationArgs = {
  scenarioLocationId: Scalars['ID'];
  updateInput: ScenarioLocationInput;
};


export type MutationUpdateTranslationsArgs = {
  archivedTranslationIds: Array<Scalars['String']>;
  newTranslations: Array<TranslationCreateInput>;
  updatedTranslations: Array<TranslationUpdateInput>;
};


export type MutationValidateEndQuizArgs = {
  gameId: Scalars['ID'];
};

export type NavigateAndFindTemplate = {
  __typename?: 'NavigateAndFindTemplate';
  blocks: Array<ContentBlock>;
  imageKey: Scalars['String'];
  locationPoints: Array<Point>;
  type: PuzzleType;
};

export type NullableImage = {
  __typename?: 'NullableImage';
  aspectRatio?: Maybe<Scalars['Float']>;
  caption?: Maybe<Scalars['String']>;
  thumbhash?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type NumberOfMovesScoreTier = {
  __typename?: 'NumberOfMovesScoreTier';
  numberOfMoves: Scalars['Int'];
  pointsReward: Scalars['Int'];
};

export type NumberOfPuzzles = {
  __typename?: 'NumberOfPuzzles';
  toSolve: Scalars['Int'];
  total: Scalars['Int'];
};

export type NumberOfTriesScoreTier = {
  __typename?: 'NumberOfTriesScoreTier';
  numberOfTries: Scalars['Int'];
  pointsReward: Scalars['Int'];
};

export type ParagraphBlock = {
  __typename?: 'ParagraphBlock';
  text: Scalars['String'];
  type: ContentBlockType;
};

export type Paving = {
  __typename?: 'Paving';
  numberOfColumns: Scalars['Int'];
  numberOfRows: Scalars['Int'];
  pavingBottonImageKey?: Maybe<Scalars['String']>;
  pavingImageKeys: Array<Scalars['String']>;
  type: SubmitBlockType;
};

export type PaymentIntent = {
  __typename?: 'PaymentIntent';
  id: Scalars['ID'];
};

export type PhotoPuzzle = {
  __typename?: 'PhotoPuzzle';
  numberOfColumns: Scalars['Int'];
  numberOfRows: Scalars['Int'];
  photoPuzzleImageKey: Scalars['String'];
  type: SubmitBlockType;
};

export type Point = {
  __typename?: 'Point';
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type PointInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type Puzzle = {
  __typename?: 'Puzzle';
  _id: Scalars['ID'];
  blockingPuzzleIds: Array<Scalars['String']>;
  expectedAnswer?: Maybe<Scalars['String']>;
  hints: Array<Scalars['String']>;
  scoreTiers?: Maybe<Array<ScoreTier>>;
  state: PuzzleState;
  submitBlock: SubmitBlock;
  template: PuzzleTemplate;
  title: Scalars['String'];
};

export type PuzzleAnswerResult = {
  __typename?: 'PuzzleAnswerResult';
  isIncorrect: Scalars['Boolean'];
  nextGamePuzzle?: Maybe<GamePuzzle>;
  score?: Maybe<Scalars['Int']>;
};

export type PuzzleResult = {
  __typename?: 'PuzzleResult';
  errors?: Maybe<Array<Scalars['String']>>;
  puzzle?: Maybe<Puzzle>;
};

export enum PuzzleState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export type PuzzleTemplate = ContentTemplate | HotAndColdTemplate | NavigateAndFindTemplate;

export type PuzzleTemplateInput = {
  blocks?: InputMaybe<Array<ContentBlockInput>>;
  imageKey?: InputMaybe<Scalars['String']>;
  locationPoints?: InputMaybe<Array<PointInput>>;
  targetLocation?: InputMaybe<PointInput>;
  type: PuzzleType;
};

export enum PuzzleType {
  Content = 'Content',
  HotAndCold = 'HotAndCold',
  NavigateAndFind = 'NavigateAndFind'
}

export type PuzzleUpdateInput = {
  blockingPuzzleIds: Array<Scalars['String']>;
  expectedAnswer?: InputMaybe<Scalars['String']>;
  hints: Array<Scalars['String']>;
  scoreTiers: Array<Scalars['String']>;
  submitBlock: SubmitBlockInput;
  template: PuzzleTemplateInput;
  title: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  activeCities: Array<City>;
  activeCollections: Array<Collection>;
  activeScenarios: Array<Scenario>;
  activeScenariosByCity: Array<City>;
  backpackItemsOfScenario: Array<BackpackItem>;
  cities: Array<City>;
  cityBySlug?: Maybe<City>;
  collection: Collection;
  collections: Array<Collection>;
  discountAuthorization: DiscountAuthorizationResult;
  discounts: Array<Discount>;
  game: Game;
  gameLocation: GameLocation;
  gameLocationsOfGame: Array<GameLocation>;
  gamePuzzle: GamePuzzle;
  gamePuzzlesOfGameLocation: Array<GamePuzzle>;
  games: Array<Game>;
  imageTranslations: Array<ImageTranslation>;
  itemsOfCollection: Array<CollectionItem>;
  nextGamePuzzle?: Maybe<GamePuzzle>;
  scenario: Scenario;
  scenarioBySlug?: Maybe<Scenario>;
  scenarioLocation: ScenarioLocation;
  scenarioLocationInfo: ScenarioLocationInfo;
  scenarioLocationPuzzles: Array<Puzzle>;
  scenarios: Array<Scenario>;
  sectionImageTranslations: Array<ImageTranslation>;
  sectionTranslations: Array<Translation>;
  translations: Array<Translation>;
  user?: Maybe<User>;
  userGames: Array<Game>;
  userPurchases: Array<Transaction>;
  users: Array<User>;
};


export type QueryBackpackItemsOfScenarioArgs = {
  scenarioId: Scalars['ID'];
};


export type QueryCityBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryCollectionArgs = {
  collectionId: Scalars['ID'];
};


export type QueryDiscountAuthorizationArgs = {
  discountId: Scalars['ID'];
  email: Scalars['String'];
};


export type QueryGameArgs = {
  gameId: Scalars['ID'];
};


export type QueryGameLocationArgs = {
  gameLocationId: Scalars['ID'];
};


export type QueryGameLocationsOfGameArgs = {
  gameId: Scalars['ID'];
};


export type QueryGamePuzzleArgs = {
  gamePuzzleId: Scalars['ID'];
};


export type QueryGamePuzzlesOfGameLocationArgs = {
  gameLocationId: Scalars['ID'];
};


export type QueryItemsOfCollectionArgs = {
  collectionId: Scalars['ID'];
};


export type QueryNextGamePuzzleArgs = {
  gameLocationId: Scalars['ID'];
};


export type QueryScenarioArgs = {
  scenarioId: Scalars['ID'];
};


export type QueryScenarioBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryScenarioLocationArgs = {
  scenarioLocationId: Scalars['ID'];
};


export type QueryScenarioLocationInfoArgs = {
  gameId: Scalars['ID'];
  scenarioLocationId: Scalars['ID'];
};


export type QueryScenarioLocationPuzzlesArgs = {
  scenarioLocationId: Scalars['ID'];
};


export type QuerySectionImageTranslationsArgs = {
  sectionId?: InputMaybe<Scalars['String']>;
};


export type QuerySectionTranslationsArgs = {
  sectionId?: InputMaybe<Scalars['String']>;
};

export type Question = {
  __typename?: 'Question';
  blocks: Array<ContentBlock>;
  expectedAnswerKey: Scalars['String'];
  labelKey: Scalars['String'];
};

export type QuestionInput = {
  blocks: Array<ContentBlockInput>;
  expectedAnswerKey: Scalars['String'];
  labelKey: Scalars['String'];
};

export type Quiz = {
  __typename?: 'Quiz';
  questions: Array<Question>;
  titleKey: Scalars['String'];
};

export type QuizInput = {
  questions: Array<QuestionInput>;
  titleKey: Scalars['String'];
};

export enum RerLine {
  RerA = 'RerA',
  RerB = 'RerB',
  RerC = 'RerC',
  RerD = 'RerD',
  RerE = 'RerE'
}

export type Review = {
  __typename?: 'Review';
  _id: Scalars['ID'];
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['GraphQLDate'];
  deviceId?: Maybe<Scalars['ID']>;
  gameId: Scalars['ID'];
  rating: Scalars['Int'];
};

export type Rotonde = {
  __typename?: 'Rotonde';
  type: SubmitBlockType;
};

export type Scenario = {
  __typename?: 'Scenario';
  _id: Scalars['ID'];
  accessibility: Scalars['String'];
  cityId: Scalars['ID'];
  conclusionBlocks: Array<ContentBlock>;
  description: Scalars['String'];
  difficulty: ScenarioDifficulty;
  distanceEstimate: Scalars['String'];
  durationEstimate: Scalars['String'];
  endQuiz: Quiz;
  imageKey: Scalars['String'];
  inAppPurchaseIdentifier?: Maybe<Scalars['ID']>;
  introductionBlocks: Array<ContentBlock>;
  landmarks: Array<Landmark>;
  meta: ScenarioMeta;
  needsHighLocationAccuracy: Scalars['Boolean'];
  numberOfPuzzles: NumberOfPuzzles;
  previewImageKeys: Array<Scalars['String']>;
  price: Scalars['Float'];
  recommendedCommuteStations: Array<CommuteStation>;
  recommendedHours: Scalars['String'];
  reviewCount: Scalars['Int'];
  reviewNote: Scalars['Float'];
  scenarioLocations: Array<ScenarioLocation>;
  showTimer: Scalars['Boolean'];
  slug: Scalars['String'];
  state: ScenarioState;
  title: Scalars['String'];
};

export enum ScenarioDifficulty {
  Easy = 'Easy',
  Hard = 'Hard',
  Medium = 'Medium'
}

export type ScenarioLocation = {
  __typename?: 'ScenarioLocation';
  _id: Scalars['ID'];
  blockingScenarioLocationIds: Array<Scalars['ID']>;
  funFacts: Array<FunFact>;
  imageKey: Scalars['String'];
  location: Point;
  numberOfPuzzles: Scalars['Int'];
  puzzles: Array<Puzzle>;
  sameScenarioLocations: Array<ScenarioLocation>;
  state: ScenarioLocationState;
  title: Scalars['String'];
  visitedLandmark?: Maybe<Scalars['String']>;
};

export type ScenarioLocationInfo = {
  __typename?: 'ScenarioLocationInfo';
  _id: Scalars['ID'];
  nextGamePuzzleId?: Maybe<Scalars['ID']>;
  progress: Scalars['Float'];
  title: Scalars['String'];
};

export type ScenarioLocationInput = {
  blockingScenarioLocationIds: Array<Scalars['String']>;
  funFacts: Array<FunFactInput>;
  imageKey: Scalars['String'];
  location: PointInput;
  title: Scalars['String'];
  visitedLandmark?: InputMaybe<Scalars['String']>;
};

export type ScenarioLocationResult = {
  __typename?: 'ScenarioLocationResult';
  errors?: Maybe<Array<Scalars['String']>>;
  scenarioLocation?: Maybe<ScenarioLocation>;
};

export enum ScenarioLocationState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export type ScenarioMeta = {
  __typename?: 'ScenarioMeta';
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ScenarioMetaInput = {
  description?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ScenarioResult = {
  __typename?: 'ScenarioResult';
  errors?: Maybe<Array<Scalars['String']>>;
  scenario?: Maybe<Scenario>;
};

export enum ScenarioState {
  Archived = 'Archived',
  InDevelopment = 'InDevelopment',
  Regular = 'Regular'
}

export type ScenarioUpdateInput = {
  accessibility: Scalars['String'];
  cityId: Scalars['ID'];
  conclusionBlocks: Array<ContentBlockInput>;
  description: Scalars['String'];
  difficulty: ScenarioDifficulty;
  distanceEstimate: Scalars['String'];
  durationEstimate: Scalars['String'];
  endQuiz: QuizInput;
  imageKey: Scalars['String'];
  introductionBlocks: Array<ContentBlockInput>;
  meta: ScenarioMetaInput;
  previewImageKeys: Array<Scalars['String']>;
  price: Scalars['Float'];
  recommendedCommuteStations: Array<CommuteStationInput>;
  recommendedHours: Scalars['String'];
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type ScoreTier = DefaultScoreTier | NumberOfMovesScoreTier | NumberOfTriesScoreTier | TimedScoreTier;

export type Select = {
  __typename?: 'Select';
  options: Array<SelectOption>;
  type: SubmitBlockType;
};

export type SelectOption = {
  __typename?: 'SelectOption';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type SelectOptionInput = {
  label: Scalars['String'];
  value: Scalars['String'];
};

export type SimonSays = {
  __typename?: 'SimonSays';
  sequence: Array<Scalars['Int']>;
  type: SubmitBlockType;
};

export type Skyline = {
  __typename?: 'Skyline';
  expectedSequence: Array<Scalars['Int']>;
  skylineOptions: Array<SkylineOption>;
  type: SubmitBlockType;
};

export enum SkylineOption {
  Bouquinistes = 'Bouquinistes',
  Chinatown = 'Chinatown',
  Conciergerie = 'Conciergerie',
  EscapeDaysArbre = 'EscapeDaysArbre',
  EscapeDaysStatue = 'EscapeDaysStatue',
  EscapeDaysTourLogement = 'EscapeDaysTourLogement',
  EscapeDaysTourRadio = 'EscapeDaysTourRadio',
  HopitalHotelDieu = 'HopitalHotelDieu',
  Montparnasse = 'Montparnasse',
  NotreDame = 'NotreDame',
  Pantheon = 'Pantheon',
  PolicePrefecture = 'PolicePrefecture',
  PrivateBuilding = 'PrivateBuilding',
  SaintVincentChurch = 'SaintVincentChurch',
  TourDuo = 'TourDuo',
  TribunalCorrectionnel = 'TribunalCorrectionnel',
  TribunalDeCommerce = 'TribunalDeCommerce'
}

export type SolvedGamePuzzleResult = {
  __typename?: 'SolvedGamePuzzleResult';
  deviceId: Scalars['ID'];
};

export type SubmitBlock = AugmentedReality | AutoPlayingSound | ButtonBlock | CameraLayer | Carousel | CesarCode | ColorLetters | CombinationPadlock | Digicode | FourDolphins | GalerieColbert | HideAndSeek | ImageAreas | ImagesOrdering | ImagesSelection | ImagesSorting | InputBlock | LightBulbs | MorseCode | MultiSelect | MusicSheet | Paving | PhotoPuzzle | Rotonde | Select | SimonSays | Skyline | Sundial | WineCellar;

export type SubmitBlockInput = {
  anchorImages?: InputMaybe<Array<AnchorImageInput>>;
  answerCells?: InputMaybe<Array<CellInput>>;
  answerImageUrl?: InputMaybe<Scalars['String']>;
  answerIndices?: InputMaybe<Array<Scalars['Int']>>;
  code?: InputMaybe<Scalars['String']>;
  colorLetters?: InputMaybe<Array<ColorLetterInput>>;
  expectedSequence?: InputMaybe<Array<Scalars['Int']>>;
  hiddenImageKey?: InputMaybe<Scalars['String']>;
  hidingImageKey?: InputMaybe<Scalars['String']>;
  imageItems?: InputMaybe<Array<ImageItemInput>>;
  imageKey?: InputMaybe<Scalars['String']>;
  imageOffUrl?: InputMaybe<Scalars['String']>;
  imageOnUrl?: InputMaybe<Scalars['String']>;
  imagesSize?: InputMaybe<Scalars['Int']>;
  inputLabel?: InputMaybe<Scalars['String']>;
  keyboardType?: InputMaybe<KeyboardType>;
  label?: InputMaybe<Scalars['String']>;
  layerImageUrl?: InputMaybe<Scalars['String']>;
  numberOfColumns?: InputMaybe<Scalars['Int']>;
  numberOfRows?: InputMaybe<Scalars['Int']>;
  optionLabels?: InputMaybe<Array<Scalars['String']>>;
  options?: InputMaybe<Array<SelectOptionInput>>;
  pavingBottonImageKey?: InputMaybe<Scalars['String']>;
  pavingImageKeys?: InputMaybe<Array<Scalars['String']>>;
  photoPuzzleImageKey?: InputMaybe<Scalars['String']>;
  placeholder?: InputMaybe<Scalars['String']>;
  plainText?: InputMaybe<Scalars['String']>;
  sequence?: InputMaybe<Array<Scalars['Int']>>;
  sequencesToGuess?: InputMaybe<Array<Array<LetterNoteInput>>>;
  skylineOptions?: InputMaybe<Array<SkylineOption>>;
  stringCode?: InputMaybe<Scalars['String']>;
  type: SubmitBlockType;
  wrongImageUrls?: InputMaybe<Array<Scalars['String']>>;
};

export enum SubmitBlockType {
  AugmentedReality = 'AugmentedReality',
  AutoPlayingSound = 'AutoPlayingSound',
  Button = 'Button',
  CameraLayer = 'CameraLayer',
  Carousel = 'Carousel',
  CesarCode = 'CesarCode',
  ColorLetters = 'ColorLetters',
  CombinationPadlock = 'CombinationPadlock',
  Digicode = 'Digicode',
  FourDolphins = 'FourDolphins',
  GalerieColbert = 'GalerieColbert',
  HideAndSeek = 'HideAndSeek',
  ImageAreas = 'ImageAreas',
  ImagesOrdering = 'ImagesOrdering',
  ImagesSelection = 'ImagesSelection',
  ImagesSorting = 'ImagesSorting',
  Input = 'Input',
  LightBulbs = 'LightBulbs',
  MorseCode = 'MorseCode',
  MultiSelect = 'MultiSelect',
  MusicSheet = 'MusicSheet',
  Paving = 'Paving',
  PhotoPuzzle = 'PhotoPuzzle',
  Rotonde = 'Rotonde',
  Select = 'Select',
  SimonSays = 'SimonSays',
  Skyline = 'Skyline',
  Sundial = 'Sundial',
  WineCellar = 'WineCellar'
}

export type Subscription = {
  __typename?: 'Subscription';
  gameLocationUpdated: GameLocation;
  gamePuzzleSolved: SolvedGamePuzzleResult;
  transactionAdded: Transaction;
};


export type SubscriptionGameLocationUpdatedArgs = {
  deviceId: Scalars['ID'];
  gameId: Scalars['ID'];
};


export type SubscriptionGamePuzzleSolvedArgs = {
  deviceId: Scalars['ID'];
  gamePuzzleId: Scalars['ID'];
};


export type SubscriptionTransactionAddedArgs = {
  deviceId: Scalars['ID'];
};

export type SubtitleBlock = {
  __typename?: 'SubtitleBlock';
  text: Scalars['String'];
  type: ContentBlockType;
};

export type SuccessAuthenticationInfo = {
  __typename?: 'SuccessAuthenticationInfo';
  admin?: Maybe<Admin>;
  success: Scalars['Boolean'];
  token?: Maybe<Scalars['String']>;
};

export type Sundial = {
  __typename?: 'Sundial';
  type: SubmitBlockType;
};

export type TimedScoreTier = {
  __typename?: 'TimedScoreTier';
  elapsedMinutes: Scalars['Int'];
  pointsReward: Scalars['Int'];
};

export type TitleBlock = {
  __typename?: 'TitleBlock';
  text: Scalars['String'];
  type: ContentBlockType;
};

export type TokenVerificationResult = {
  __typename?: 'TokenVerificationResult';
  admin?: Maybe<Admin>;
};

export type Transaction = {
  __typename?: 'Transaction';
  _id: Scalars['ID'];
  createdAt: Scalars['GraphQLDate'];
  game: Game;
  origin: TransactionOrigin;
  priceDetails: TransactionPrice;
  user: User;
};

export enum TransactionOrigin {
  Free = 'Free',
  InAppPurchase = 'InAppPurchase',
  Stripe = 'Stripe'
}

export type TransactionPrice = {
  __typename?: 'TransactionPrice';
  discount: Scalars['Int'];
  paid: Scalars['Int'];
  total: Scalars['Int'];
};

export type Translation = {
  __typename?: 'Translation';
  _id: Scalars['ID'];
  createdAt: Scalars['GraphQLDate'];
  english: Scalars['String'];
  french: Scalars['String'];
  isGlobal: Scalars['Boolean'];
  key: Scalars['String'];
  sectionId: Scalars['String'];
  state: TranslationState;
  updatedAt: Scalars['GraphQLDate'];
};

export type TranslationCreateInput = {
  english: Scalars['String'];
  french: Scalars['String'];
  isGlobal: Scalars['Boolean'];
  key: Scalars['String'];
  sectionId: Scalars['String'];
};

export enum TranslationState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export type TranslationUpdateInput = {
  _id: Scalars['String'];
  english: Scalars['String'];
  french: Scalars['String'];
  isGlobal: Scalars['Boolean'];
  key: Scalars['String'];
  sectionId: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  _id: Scalars['ID'];
  deviceId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  stripeCustomerId?: Maybe<Scalars['String']>;
};

export type UserInfo = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  language: Language;
  lastName: Scalars['String'];
};

export type WineCellar = {
  __typename?: 'WineCellar';
  type: SubmitBlockType;
};

export type BackpackItemFragment = { __typename?: 'BackpackItem', _id: string, scenarioId: string, blockingScenarioLocationId?: string | null, imageKey: string, state: BackpackItemState, title: string, description: string };

export type CollectionFragment = { __typename?: 'Collection', _id: string, areaRadius?: number | null, imageKey: string, name: string, numberOfItems: number, state: CollectionState, type: CollectionType, image: { __typename?: 'Image', aspectRatio: number, caption?: string | null, thumbhash: string, url: string } };

export type CollectionItemFragment = { __typename?: 'CollectionItem', _id: string, imageKey: string, name: string, fuzzyLocation?: { __typename?: 'Point', latitude: number, longitude: number } | null, image: { __typename?: 'Image', aspectRatio: number, caption?: string | null, thumbhash: string, url: string }, location: { __typename?: 'Point', latitude: number, longitude: number } };

type ContentBlockEquationsBlockFragment = { __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> };

type ContentBlockImageBlockFragment = { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string };

type ContentBlockParagraphBlockFragment = { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string };

type ContentBlockSubtitleBlockFragment = { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string };

type ContentBlockTitleBlockFragment = { __typename?: 'TitleBlock', type: ContentBlockType, text: string };

export type ContentBlockFragment = ContentBlockEquationsBlockFragment | ContentBlockImageBlockFragment | ContentBlockParagraphBlockFragment | ContentBlockSubtitleBlockFragment | ContentBlockTitleBlockFragment;

export type GameFragment = { __typename?: 'Game', _id: string, completedAt?: any | null, createdAt: any, isInDemoMode: boolean, joinCode: string, startedAt?: any | null, state: GameState, gameLocations: Array<{ __typename?: 'GameLocation', _id: string, completedAt?: any | null, startedAt?: any | null, state: GameLocationState, gamePuzzles: Array<{ __typename?: 'GamePuzzle', _id: string, completedAt?: any | null, guesses: Array<string | null>, numberOfUsedHints: number, startedAt?: any | null, state: GamePuzzleState, puzzle: { __typename?: 'Puzzle', _id: string, blockingPuzzleIds: Array<string>, title: string } }>, scenarioLocation: { __typename?: 'ScenarioLocation', _id: string, blockingScenarioLocationIds: Array<string>, imageKey: string, title: string } }>, scenario: { __typename?: 'Scenario', imageKey: string, title: string }, transaction?: { __typename?: 'Transaction', origin: TransactionOrigin, priceDetails: { __typename?: 'TransactionPrice', total: number, paid: number, discount: number } } | null, user: { __typename?: 'User', email: string, firstName: string, lastName: string } };

export type GameLocationFragment = { __typename?: 'GameLocation', _id: string, completedAt?: any | null, startedAt?: any | null, state: GameLocationState, gamePuzzles: Array<{ __typename?: 'GamePuzzle', _id: string, completedAt?: any | null, guesses: Array<string | null>, numberOfUsedHints: number, startedAt?: any | null, state: GamePuzzleState, puzzle: { __typename?: 'Puzzle', _id: string, blockingPuzzleIds: Array<string>, title: string } }>, scenarioLocation: { __typename?: 'ScenarioLocation', _id: string, blockingScenarioLocationIds: Array<string>, imageKey: string, title: string } };

export type GamePuzzleFragment = { __typename?: 'GamePuzzle', _id: string, completedAt?: any | null, guesses: Array<string | null>, numberOfUsedHints: number, startedAt?: any | null, state: GamePuzzleState, puzzle: { __typename?: 'Puzzle', _id: string, blockingPuzzleIds: Array<string>, title: string } };

export type ImageFragment = { __typename?: 'Image', aspectRatio: number, caption?: string | null, thumbhash: string, url: string };

export type NullableImageFragment = { __typename?: 'NullableImage', aspectRatio?: number | null, caption?: string | null, thumbhash?: string | null, url?: string | null };

export type ImageTranslationFragment = { __typename?: 'ImageTranslation', _id: string, key: string, isGlobal: boolean, sectionId: string, french: { __typename?: 'Image', aspectRatio: number, caption?: string | null, thumbhash: string, url: string }, english: { __typename?: 'NullableImage', aspectRatio?: number | null, caption?: string | null, thumbhash?: string | null, url?: string | null } };

export type LandmarkFragment = { __typename?: 'Landmark', _id: string, imageKey: string, scenarioId: string, state: LandmarkState, title: string, blocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }>, location: { __typename?: 'Point', latitude: number, longitude: number } };

type ScoreTierDefaultScoreTierFragment = { __typename?: 'DefaultScoreTier', pointsReward: number };

type ScoreTierNumberOfMovesScoreTierFragment = { __typename?: 'NumberOfMovesScoreTier', numberOfMoves: number, pointsReward: number };

type ScoreTierNumberOfTriesScoreTierFragment = { __typename?: 'NumberOfTriesScoreTier', numberOfTries: number, pointsReward: number };

type ScoreTierTimedScoreTierFragment = { __typename?: 'TimedScoreTier', elapsedMinutes: number, pointsReward: number };

export type ScoreTierFragment = ScoreTierDefaultScoreTierFragment | ScoreTierNumberOfMovesScoreTierFragment | ScoreTierNumberOfTriesScoreTierFragment | ScoreTierTimedScoreTierFragment;

type PuzzleTemplateContentTemplateFragment = { __typename?: 'ContentTemplate', type: PuzzleType, blocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }> };

type PuzzleTemplateHotAndColdTemplateFragment = { __typename?: 'HotAndColdTemplate', type: PuzzleType, targetLocation: { __typename?: 'Point', latitude: number, longitude: number }, blocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }> };

type PuzzleTemplateNavigateAndFindTemplateFragment = { __typename?: 'NavigateAndFindTemplate', type: PuzzleType, imageKey: string, locationPoints: Array<{ __typename?: 'Point', latitude: number, longitude: number }>, blocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }> };

export type PuzzleTemplateFragment = PuzzleTemplateContentTemplateFragment | PuzzleTemplateHotAndColdTemplateFragment | PuzzleTemplateNavigateAndFindTemplateFragment;

export type PuzzleFragment = { __typename?: 'Puzzle', _id: string, blockingPuzzleIds: Array<string>, expectedAnswer?: string | null, hints: Array<string>, state: PuzzleState, title: string, scoreTiers?: Array<{ __typename?: 'DefaultScoreTier', pointsReward: number } | { __typename?: 'NumberOfMovesScoreTier', numberOfMoves: number, pointsReward: number } | { __typename?: 'NumberOfTriesScoreTier', numberOfTries: number, pointsReward: number } | { __typename?: 'TimedScoreTier', elapsedMinutes: number, pointsReward: number }> | null, submitBlock: { __typename?: 'AugmentedReality', type: SubmitBlockType, anchorImages: Array<{ __typename?: 'AnchorImages', url: string, physicalWidth: number, name: string, hiddenMessage: string }> } | { __typename?: 'AutoPlayingSound', type: SubmitBlockType } | { __typename?: 'ButtonBlock', type: SubmitBlockType, label: string } | { __typename?: 'CameraLayer', type: SubmitBlockType, layerImageUrl: string } | { __typename?: 'Carousel', type: SubmitBlockType, answerImageUrl: string, wrongImageUrls: Array<string>, imagesSize: number } | { __typename?: 'CesarCode', type: SubmitBlockType, stringCode: string, plainText: string } | { __typename?: 'ColorLetters', type: SubmitBlockType, colorLetters: Array<{ __typename?: 'ColorLetter', color: string, letter: string }> } | { __typename?: 'CombinationPadlock', type: SubmitBlockType } | { __typename?: 'Digicode', type: SubmitBlockType } | { __typename?: 'FourDolphins', type: SubmitBlockType } | { __typename?: 'GalerieColbert', type: SubmitBlockType } | { __typename?: 'HideAndSeek', type: SubmitBlockType, hidingImageKey: string, hiddenImageKey: string } | { __typename?: 'ImageAreas', type: SubmitBlockType, numberOfRows: number, numberOfColumns: number, imageKey: string, answerCells: Array<{ __typename?: 'Cell', row: number, column: number }> } | { __typename?: 'ImagesOrdering', type: SubmitBlockType, imageItems: Array<{ __typename?: 'ImagesOrderingItem', imageKey: string, isInitiallyRevealed: boolean, position: number }> } | { __typename?: 'ImagesSelection', type: SubmitBlockType, imageItems: Array<{ __typename?: 'ImagesSelectionItem', imageKey: string, isCorrect: boolean }> } | { __typename?: 'ImagesSorting', type: SubmitBlockType, imageItems: Array<{ __typename?: 'ImagesSortingItem', imageKey: string, position: number }> } | { __typename?: 'InputBlock', type: SubmitBlockType, inputLabel?: string | null, keyboardType?: KeyboardType | null, placeholder?: string | null } | { __typename?: 'LightBulbs', type: SubmitBlockType, imageOnUrl: string, imageOffUrl: string } | { __typename?: 'MorseCode', type: SubmitBlockType, code: string } | { __typename?: 'MultiSelect', type: SubmitBlockType, answerIndices: Array<number>, optionLabels: Array<string> } | { __typename?: 'MusicSheet', type: SubmitBlockType, sequencesToGuess: Array<Array<{ __typename?: 'LetterNote', letter: string, noteIndex: number }>> } | { __typename?: 'Paving', type: SubmitBlockType, numberOfColumns: number, numberOfRows: number, pavingImageKeys: Array<string>, pavingBottonImageKey?: string | null } | { __typename?: 'PhotoPuzzle', type: SubmitBlockType, numberOfColumns: number, numberOfRows: number, photoPuzzleImageKey: string } | { __typename?: 'Rotonde', type: SubmitBlockType } | { __typename?: 'Select', type: SubmitBlockType, options: Array<{ __typename?: 'SelectOption', value: string, label: string }> } | { __typename?: 'SimonSays', type: SubmitBlockType, sequence: Array<number> } | { __typename?: 'Skyline', type: SubmitBlockType, skylineOptions: Array<SkylineOption>, expectedSequence: Array<number> } | { __typename?: 'Sundial', type: SubmitBlockType } | { __typename?: 'WineCellar', type: SubmitBlockType }, template: { __typename?: 'ContentTemplate', type: PuzzleType, blocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }> } | { __typename?: 'HotAndColdTemplate', type: PuzzleType, targetLocation: { __typename?: 'Point', latitude: number, longitude: number }, blocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }> } | { __typename?: 'NavigateAndFindTemplate', type: PuzzleType, imageKey: string, locationPoints: Array<{ __typename?: 'Point', latitude: number, longitude: number }>, blocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }> } };

export type QuizFragment = { __typename?: 'Quiz', titleKey: string, questions: Array<{ __typename?: 'Question', expectedAnswerKey: string, labelKey: string, blocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }> }> };

export type ScenarioFragment = { __typename?: 'Scenario', _id: string, accessibility: string, cityId: string, description: string, difficulty: ScenarioDifficulty, distanceEstimate: string, durationEstimate: string, imageKey: string, previewImageKeys: Array<string>, price: number, recommendedHours: string, slug: string, state: ScenarioState, title: string, conclusionBlocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }>, endQuiz: { __typename?: 'Quiz', titleKey: string, questions: Array<{ __typename?: 'Question', expectedAnswerKey: string, labelKey: string, blocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }> }> }, introductionBlocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }>, meta: { __typename?: 'ScenarioMeta', title?: string | null, description?: string | null }, recommendedCommuteStations: Array<{ __typename?: 'CommuteStation', description?: string | null, name: string, commuteLines: { __typename?: 'CommuteLines', metroLines: Array<MetroLine>, rerLines: Array<RerLine> } }> };

export type FunFactFragment = { __typename?: 'FunFact', title?: string | null, text: string, imageKey?: string | null };

export type ScenarioLocationFragment = { __typename?: 'ScenarioLocation', _id: string, blockingScenarioLocationIds: Array<string>, imageKey: string, state: ScenarioLocationState, title: string, visitedLandmark?: string | null, funFacts: Array<{ __typename?: 'FunFact', title?: string | null, text: string, imageKey?: string | null }>, location: { __typename?: 'Point', latitude: number, longitude: number } };

export type ScenarioLocationOfScenarioFragment = { __typename?: 'ScenarioLocation', _id: string, blockingScenarioLocationIds: Array<string>, imageKey: string, numberOfPuzzles: number, title: string, funFacts: Array<{ __typename?: 'FunFact', title?: string | null, text: string, imageKey?: string | null }>, location: { __typename?: 'Point', latitude: number, longitude: number } };

type SubmitBlockAugmentedRealityFragment = { __typename?: 'AugmentedReality', type: SubmitBlockType, anchorImages: Array<{ __typename?: 'AnchorImages', url: string, physicalWidth: number, name: string, hiddenMessage: string }> };

type SubmitBlockAutoPlayingSoundFragment = { __typename?: 'AutoPlayingSound', type: SubmitBlockType };

type SubmitBlockButtonBlockFragment = { __typename?: 'ButtonBlock', type: SubmitBlockType, label: string };

type SubmitBlockCameraLayerFragment = { __typename?: 'CameraLayer', type: SubmitBlockType, layerImageUrl: string };

type SubmitBlockCarouselFragment = { __typename?: 'Carousel', type: SubmitBlockType, answerImageUrl: string, wrongImageUrls: Array<string>, imagesSize: number };

type SubmitBlockCesarCodeFragment = { __typename?: 'CesarCode', type: SubmitBlockType, stringCode: string, plainText: string };

type SubmitBlockColorLettersFragment = { __typename?: 'ColorLetters', type: SubmitBlockType, colorLetters: Array<{ __typename?: 'ColorLetter', color: string, letter: string }> };

type SubmitBlockCombinationPadlockFragment = { __typename?: 'CombinationPadlock', type: SubmitBlockType };

type SubmitBlockDigicodeFragment = { __typename?: 'Digicode', type: SubmitBlockType };

type SubmitBlockFourDolphinsFragment = { __typename?: 'FourDolphins', type: SubmitBlockType };

type SubmitBlockGalerieColbertFragment = { __typename?: 'GalerieColbert', type: SubmitBlockType };

type SubmitBlockHideAndSeekFragment = { __typename?: 'HideAndSeek', type: SubmitBlockType, hidingImageKey: string, hiddenImageKey: string };

type SubmitBlockImageAreasFragment = { __typename?: 'ImageAreas', type: SubmitBlockType, numberOfRows: number, numberOfColumns: number, imageKey: string, answerCells: Array<{ __typename?: 'Cell', row: number, column: number }> };

type SubmitBlockImagesOrderingFragment = { __typename?: 'ImagesOrdering', type: SubmitBlockType, imageItems: Array<{ __typename?: 'ImagesOrderingItem', imageKey: string, isInitiallyRevealed: boolean, position: number }> };

type SubmitBlockImagesSelectionFragment = { __typename?: 'ImagesSelection', type: SubmitBlockType, imageItems: Array<{ __typename?: 'ImagesSelectionItem', imageKey: string, isCorrect: boolean }> };

type SubmitBlockImagesSortingFragment = { __typename?: 'ImagesSorting', type: SubmitBlockType, imageItems: Array<{ __typename?: 'ImagesSortingItem', imageKey: string, position: number }> };

type SubmitBlockInputBlockFragment = { __typename?: 'InputBlock', type: SubmitBlockType, inputLabel?: string | null, keyboardType?: KeyboardType | null, placeholder?: string | null };

type SubmitBlockLightBulbsFragment = { __typename?: 'LightBulbs', type: SubmitBlockType, imageOnUrl: string, imageOffUrl: string };

type SubmitBlockMorseCodeFragment = { __typename?: 'MorseCode', type: SubmitBlockType, code: string };

type SubmitBlockMultiSelectFragment = { __typename?: 'MultiSelect', type: SubmitBlockType, answerIndices: Array<number>, optionLabels: Array<string> };

type SubmitBlockMusicSheetFragment = { __typename?: 'MusicSheet', type: SubmitBlockType, sequencesToGuess: Array<Array<{ __typename?: 'LetterNote', letter: string, noteIndex: number }>> };

type SubmitBlockPavingFragment = { __typename?: 'Paving', type: SubmitBlockType, numberOfColumns: number, numberOfRows: number, pavingImageKeys: Array<string>, pavingBottonImageKey?: string | null };

type SubmitBlockPhotoPuzzleFragment = { __typename?: 'PhotoPuzzle', type: SubmitBlockType, numberOfColumns: number, numberOfRows: number, photoPuzzleImageKey: string };

type SubmitBlockRotondeFragment = { __typename?: 'Rotonde', type: SubmitBlockType };

type SubmitBlockSelectFragment = { __typename?: 'Select', type: SubmitBlockType, options: Array<{ __typename?: 'SelectOption', value: string, label: string }> };

type SubmitBlockSimonSaysFragment = { __typename?: 'SimonSays', type: SubmitBlockType, sequence: Array<number> };

type SubmitBlockSkylineFragment = { __typename?: 'Skyline', type: SubmitBlockType, skylineOptions: Array<SkylineOption>, expectedSequence: Array<number> };

type SubmitBlockSundialFragment = { __typename?: 'Sundial', type: SubmitBlockType };

type SubmitBlockWineCellarFragment = { __typename?: 'WineCellar', type: SubmitBlockType };

export type SubmitBlockFragment = SubmitBlockAugmentedRealityFragment | SubmitBlockAutoPlayingSoundFragment | SubmitBlockButtonBlockFragment | SubmitBlockCameraLayerFragment | SubmitBlockCarouselFragment | SubmitBlockCesarCodeFragment | SubmitBlockColorLettersFragment | SubmitBlockCombinationPadlockFragment | SubmitBlockDigicodeFragment | SubmitBlockFourDolphinsFragment | SubmitBlockGalerieColbertFragment | SubmitBlockHideAndSeekFragment | SubmitBlockImageAreasFragment | SubmitBlockImagesOrderingFragment | SubmitBlockImagesSelectionFragment | SubmitBlockImagesSortingFragment | SubmitBlockInputBlockFragment | SubmitBlockLightBulbsFragment | SubmitBlockMorseCodeFragment | SubmitBlockMultiSelectFragment | SubmitBlockMusicSheetFragment | SubmitBlockPavingFragment | SubmitBlockPhotoPuzzleFragment | SubmitBlockRotondeFragment | SubmitBlockSelectFragment | SubmitBlockSimonSaysFragment | SubmitBlockSkylineFragment | SubmitBlockSundialFragment | SubmitBlockWineCellarFragment;

export type TranslationFragment = { __typename?: 'Translation', _id: string, key: string, isGlobal: boolean, sectionId: string, french: string, english: string };

export type LoginAdminMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginAdminMutation = { __typename?: 'Mutation', loginAdmin: { __typename?: 'ErrorAuthenticationInfo', success: boolean, error?: string | null } | { __typename?: 'SuccessAuthenticationInfo', success: boolean, token?: string | null, admin?: { __typename?: 'Admin', _id: string, email: string } | null } };

export type VerifyTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type VerifyTokenMutation = { __typename?: 'Mutation', verifyToken: { __typename?: 'TokenVerificationResult', admin?: { __typename?: 'Admin', _id: string, email: string } | null } };

export type CreateBackpackItemMutationVariables = Exact<{
  backpackItemInput: BackpackItemInput;
  scenarioId: Scalars['ID'];
}>;


export type CreateBackpackItemMutation = { __typename?: 'Mutation', createBackpackItem: { __typename?: 'BackpackItemResult', errors?: Array<string> | null, backpackItem?: { __typename?: 'BackpackItem', _id: string, scenarioId: string, blockingScenarioLocationId?: string | null, imageKey: string, state: BackpackItemState, title: string, description: string } | null } };

export type UpdateBackpackItemMutationVariables = Exact<{
  backpackItemId: Scalars['ID'];
  updateInput: BackpackItemInput;
}>;


export type UpdateBackpackItemMutation = { __typename?: 'Mutation', updateBackpackItem: { __typename?: 'BackpackItemResult', errors?: Array<string> | null, backpackItem?: { __typename?: 'BackpackItem', _id: string, scenarioId: string, blockingScenarioLocationId?: string | null, imageKey: string, state: BackpackItemState, title: string, description: string } | null } };

export type ArchiveBackpackItemMutationVariables = Exact<{
  backpackItemId: Scalars['ID'];
}>;


export type ArchiveBackpackItemMutation = { __typename?: 'Mutation', archiveBackpackItem: { __typename?: 'BackpackItemResult', errors?: Array<string> | null, backpackItem?: { __typename?: 'BackpackItem', _id: string, scenarioId: string, blockingScenarioLocationId?: string | null, imageKey: string, state: BackpackItemState, title: string, description: string } | null } };

export type CreateCollectionItemMutationVariables = Exact<{
  collectionId: Scalars['ID'];
  collectionItemInput: CreateCollectionItemInput;
}>;


export type CreateCollectionItemMutation = { __typename?: 'Mutation', createCollectionItem: { __typename?: 'CollectionItemResult', errors?: Array<string> | null, collectionItem?: { __typename?: 'CollectionItem', _id: string, imageKey: string, name: string, fuzzyLocation?: { __typename?: 'Point', latitude: number, longitude: number } | null, image: { __typename?: 'Image', aspectRatio: number, caption?: string | null, thumbhash: string, url: string }, location: { __typename?: 'Point', latitude: number, longitude: number } } | null } };

export type CreateGameMutationVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  language: Language;
  email: Scalars['String'];
  scenarioId: Scalars['ID'];
}>;


export type CreateGameMutation = { __typename?: 'Mutation', createGame: { __typename?: 'Transaction', game: { __typename?: 'Game', _id: string, completedAt?: any | null, createdAt: any, isInDemoMode: boolean, joinCode: string, startedAt?: any | null, state: GameState, gameLocations: Array<{ __typename?: 'GameLocation', _id: string, completedAt?: any | null, startedAt?: any | null, state: GameLocationState, gamePuzzles: Array<{ __typename?: 'GamePuzzle', _id: string, completedAt?: any | null, guesses: Array<string | null>, numberOfUsedHints: number, startedAt?: any | null, state: GamePuzzleState, puzzle: { __typename?: 'Puzzle', _id: string, blockingPuzzleIds: Array<string>, title: string } }>, scenarioLocation: { __typename?: 'ScenarioLocation', _id: string, blockingScenarioLocationIds: Array<string>, imageKey: string, title: string } }>, scenario: { __typename?: 'Scenario', imageKey: string, title: string }, transaction?: { __typename?: 'Transaction', origin: TransactionOrigin, priceDetails: { __typename?: 'TransactionPrice', total: number, paid: number, discount: number } } | null, user: { __typename?: 'User', email: string, firstName: string, lastName: string } } } };

export type UpdateGamePuzzleStateMutationVariables = Exact<{
  gamePuzzleId: Scalars['ID'];
  state: GamePuzzleState;
}>;


export type UpdateGamePuzzleStateMutation = { __typename?: 'Mutation', updateGamePuzzleState: { __typename?: 'Game', _id: string, state: GameState, gameLocations: Array<{ __typename?: 'GameLocation', _id: string, completedAt?: any | null, state: GameLocationState, gamePuzzles: Array<{ __typename?: 'GamePuzzle', _id: string, completedAt?: any | null, state: GamePuzzleState }> }> } };

export type UpdateImageTranslationsMutationVariables = Exact<{
  archivedImageTranslationIds: Array<Scalars['ID']> | Scalars['ID'];
  newImageTranslations: Array<ImageTranslationCreateInput> | ImageTranslationCreateInput;
  updatedImageTranslations: Array<ImageTranslationUpdateInput> | ImageTranslationUpdateInput;
}>;


export type UpdateImageTranslationsMutation = { __typename?: 'Mutation', updateImageTranslations: { __typename?: 'ImageTranslationUpdateResult', errors: Array<string>, imageTranslations: Array<{ __typename?: 'ImageTranslation', _id: string, key: string, isGlobal: boolean, sectionId: string, french: { __typename?: 'Image', aspectRatio: number, caption?: string | null, thumbhash: string, url: string }, english: { __typename?: 'NullableImage', aspectRatio?: number | null, caption?: string | null, thumbhash?: string | null, url?: string | null } }> } };

export type ArchiveLandmarkMutationVariables = Exact<{
  landmarkId: Scalars['ID'];
}>;


export type ArchiveLandmarkMutation = { __typename?: 'Mutation', archiveLandmark: { __typename?: 'LandmarkResult', errors?: Array<string> | null, landmark?: { __typename?: 'Landmark', _id: string, imageKey: string, scenarioId: string, state: LandmarkState, title: string, blocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }>, location: { __typename?: 'Point', latitude: number, longitude: number } } | null } };

export type CreateLandmarkMutationVariables = Exact<{
  landmarkInput: LandmarkInput;
}>;


export type CreateLandmarkMutation = { __typename?: 'Mutation', createLandmark: { __typename?: 'LandmarkResult', errors?: Array<string> | null, landmark?: { __typename?: 'Landmark', _id: string, imageKey: string, scenarioId: string, state: LandmarkState, title: string, blocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }>, location: { __typename?: 'Point', latitude: number, longitude: number } } | null } };

export type UpdateLandmarkMutationVariables = Exact<{
  landmarkId: Scalars['ID'];
  updateInput: LandmarkUpdateInput;
}>;


export type UpdateLandmarkMutation = { __typename?: 'Mutation', updateLandmark: { __typename?: 'LandmarkResult', errors?: Array<string> | null, landmark?: { __typename?: 'Landmark', _id: string, imageKey: string, scenarioId: string, state: LandmarkState, title: string, blocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }>, location: { __typename?: 'Point', latitude: number, longitude: number } } | null } };

export type UpdateLandmarksLocationsMutationVariables = Exact<{
  landmarkIdsAndLocations: Array<LandmarkIdAndLocationInput> | LandmarkIdAndLocationInput;
}>;


export type UpdateLandmarksLocationsMutation = { __typename?: 'Mutation', updateLandmarksLocations: { __typename?: 'LandmarksResult', errors?: Array<string> | null, landmarks?: Array<{ __typename?: 'Landmark', _id: string, imageKey: string, scenarioId: string, state: LandmarkState, title: string, blocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }>, location: { __typename?: 'Point', latitude: number, longitude: number } }> | null } };

export type CreatePuzzleMutationVariables = Exact<{
  puzzleInput: CreatePuzzleInput;
}>;


export type CreatePuzzleMutation = { __typename?: 'Mutation', createPuzzle: { __typename?: 'PuzzleResult', errors?: Array<string> | null, puzzle?: { __typename?: 'Puzzle', _id: string, blockingPuzzleIds: Array<string>, expectedAnswer?: string | null, hints: Array<string>, state: PuzzleState, title: string, scoreTiers?: Array<{ __typename?: 'DefaultScoreTier', pointsReward: number } | { __typename?: 'NumberOfMovesScoreTier', numberOfMoves: number, pointsReward: number } | { __typename?: 'NumberOfTriesScoreTier', numberOfTries: number, pointsReward: number } | { __typename?: 'TimedScoreTier', elapsedMinutes: number, pointsReward: number }> | null, submitBlock: { __typename?: 'AugmentedReality', type: SubmitBlockType, anchorImages: Array<{ __typename?: 'AnchorImages', url: string, physicalWidth: number, name: string, hiddenMessage: string }> } | { __typename?: 'AutoPlayingSound', type: SubmitBlockType } | { __typename?: 'ButtonBlock', type: SubmitBlockType, label: string } | { __typename?: 'CameraLayer', type: SubmitBlockType, layerImageUrl: string } | { __typename?: 'Carousel', type: SubmitBlockType, answerImageUrl: string, wrongImageUrls: Array<string>, imagesSize: number } | { __typename?: 'CesarCode', type: SubmitBlockType, stringCode: string, plainText: string } | { __typename?: 'ColorLetters', type: SubmitBlockType, colorLetters: Array<{ __typename?: 'ColorLetter', color: string, letter: string }> } | { __typename?: 'CombinationPadlock', type: SubmitBlockType } | { __typename?: 'Digicode', type: SubmitBlockType } | { __typename?: 'FourDolphins', type: SubmitBlockType } | { __typename?: 'GalerieColbert', type: SubmitBlockType } | { __typename?: 'HideAndSeek', type: SubmitBlockType, hidingImageKey: string, hiddenImageKey: string } | { __typename?: 'ImageAreas', type: SubmitBlockType, numberOfRows: number, numberOfColumns: number, imageKey: string, answerCells: Array<{ __typename?: 'Cell', row: number, column: number }> } | { __typename?: 'ImagesOrdering', type: SubmitBlockType, imageItems: Array<{ __typename?: 'ImagesOrderingItem', imageKey: string, isInitiallyRevealed: boolean, position: number }> } | { __typename?: 'ImagesSelection', type: SubmitBlockType, imageItems: Array<{ __typename?: 'ImagesSelectionItem', imageKey: string, isCorrect: boolean }> } | { __typename?: 'ImagesSorting', type: SubmitBlockType, imageItems: Array<{ __typename?: 'ImagesSortingItem', imageKey: string, position: number }> } | { __typename?: 'InputBlock', type: SubmitBlockType, inputLabel?: string | null, keyboardType?: KeyboardType | null, placeholder?: string | null } | { __typename?: 'LightBulbs', type: SubmitBlockType, imageOnUrl: string, imageOffUrl: string } | { __typename?: 'MorseCode', type: SubmitBlockType, code: string } | { __typename?: 'MultiSelect', type: SubmitBlockType, answerIndices: Array<number>, optionLabels: Array<string> } | { __typename?: 'MusicSheet', type: SubmitBlockType, sequencesToGuess: Array<Array<{ __typename?: 'LetterNote', letter: string, noteIndex: number }>> } | { __typename?: 'Paving', type: SubmitBlockType, numberOfColumns: number, numberOfRows: number, pavingImageKeys: Array<string>, pavingBottonImageKey?: string | null } | { __typename?: 'PhotoPuzzle', type: SubmitBlockType, numberOfColumns: number, numberOfRows: number, photoPuzzleImageKey: string } | { __typename?: 'Rotonde', type: SubmitBlockType } | { __typename?: 'Select', type: SubmitBlockType, options: Array<{ __typename?: 'SelectOption', value: string, label: string }> } | { __typename?: 'SimonSays', type: SubmitBlockType, sequence: Array<number> } | { __typename?: 'Skyline', type: SubmitBlockType, skylineOptions: Array<SkylineOption>, expectedSequence: Array<number> } | { __typename?: 'Sundial', type: SubmitBlockType } | { __typename?: 'WineCellar', type: SubmitBlockType }, template: { __typename?: 'ContentTemplate', type: PuzzleType, blocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }> } | { __typename?: 'HotAndColdTemplate', type: PuzzleType, targetLocation: { __typename?: 'Point', latitude: number, longitude: number }, blocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }> } | { __typename?: 'NavigateAndFindTemplate', type: PuzzleType, imageKey: string, locationPoints: Array<{ __typename?: 'Point', latitude: number, longitude: number }>, blocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }> } } | null } };

export type UpdatePuzzleMutationVariables = Exact<{
  puzzleId: Scalars['ID'];
  updateInput: PuzzleUpdateInput;
}>;


export type UpdatePuzzleMutation = { __typename?: 'Mutation', updatePuzzle: { __typename?: 'PuzzleResult', errors?: Array<string> | null, puzzle?: { __typename?: 'Puzzle', _id: string, blockingPuzzleIds: Array<string>, expectedAnswer?: string | null, hints: Array<string>, state: PuzzleState, title: string, scoreTiers?: Array<{ __typename?: 'DefaultScoreTier', pointsReward: number } | { __typename?: 'NumberOfMovesScoreTier', numberOfMoves: number, pointsReward: number } | { __typename?: 'NumberOfTriesScoreTier', numberOfTries: number, pointsReward: number } | { __typename?: 'TimedScoreTier', elapsedMinutes: number, pointsReward: number }> | null, submitBlock: { __typename?: 'AugmentedReality', type: SubmitBlockType, anchorImages: Array<{ __typename?: 'AnchorImages', url: string, physicalWidth: number, name: string, hiddenMessage: string }> } | { __typename?: 'AutoPlayingSound', type: SubmitBlockType } | { __typename?: 'ButtonBlock', type: SubmitBlockType, label: string } | { __typename?: 'CameraLayer', type: SubmitBlockType, layerImageUrl: string } | { __typename?: 'Carousel', type: SubmitBlockType, answerImageUrl: string, wrongImageUrls: Array<string>, imagesSize: number } | { __typename?: 'CesarCode', type: SubmitBlockType, stringCode: string, plainText: string } | { __typename?: 'ColorLetters', type: SubmitBlockType, colorLetters: Array<{ __typename?: 'ColorLetter', color: string, letter: string }> } | { __typename?: 'CombinationPadlock', type: SubmitBlockType } | { __typename?: 'Digicode', type: SubmitBlockType } | { __typename?: 'FourDolphins', type: SubmitBlockType } | { __typename?: 'GalerieColbert', type: SubmitBlockType } | { __typename?: 'HideAndSeek', type: SubmitBlockType, hidingImageKey: string, hiddenImageKey: string } | { __typename?: 'ImageAreas', type: SubmitBlockType, numberOfRows: number, numberOfColumns: number, imageKey: string, answerCells: Array<{ __typename?: 'Cell', row: number, column: number }> } | { __typename?: 'ImagesOrdering', type: SubmitBlockType, imageItems: Array<{ __typename?: 'ImagesOrderingItem', imageKey: string, isInitiallyRevealed: boolean, position: number }> } | { __typename?: 'ImagesSelection', type: SubmitBlockType, imageItems: Array<{ __typename?: 'ImagesSelectionItem', imageKey: string, isCorrect: boolean }> } | { __typename?: 'ImagesSorting', type: SubmitBlockType, imageItems: Array<{ __typename?: 'ImagesSortingItem', imageKey: string, position: number }> } | { __typename?: 'InputBlock', type: SubmitBlockType, inputLabel?: string | null, keyboardType?: KeyboardType | null, placeholder?: string | null } | { __typename?: 'LightBulbs', type: SubmitBlockType, imageOnUrl: string, imageOffUrl: string } | { __typename?: 'MorseCode', type: SubmitBlockType, code: string } | { __typename?: 'MultiSelect', type: SubmitBlockType, answerIndices: Array<number>, optionLabels: Array<string> } | { __typename?: 'MusicSheet', type: SubmitBlockType, sequencesToGuess: Array<Array<{ __typename?: 'LetterNote', letter: string, noteIndex: number }>> } | { __typename?: 'Paving', type: SubmitBlockType, numberOfColumns: number, numberOfRows: number, pavingImageKeys: Array<string>, pavingBottonImageKey?: string | null } | { __typename?: 'PhotoPuzzle', type: SubmitBlockType, numberOfColumns: number, numberOfRows: number, photoPuzzleImageKey: string } | { __typename?: 'Rotonde', type: SubmitBlockType } | { __typename?: 'Select', type: SubmitBlockType, options: Array<{ __typename?: 'SelectOption', value: string, label: string }> } | { __typename?: 'SimonSays', type: SubmitBlockType, sequence: Array<number> } | { __typename?: 'Skyline', type: SubmitBlockType, skylineOptions: Array<SkylineOption>, expectedSequence: Array<number> } | { __typename?: 'Sundial', type: SubmitBlockType } | { __typename?: 'WineCellar', type: SubmitBlockType }, template: { __typename?: 'ContentTemplate', type: PuzzleType, blocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }> } | { __typename?: 'HotAndColdTemplate', type: PuzzleType, targetLocation: { __typename?: 'Point', latitude: number, longitude: number }, blocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }> } | { __typename?: 'NavigateAndFindTemplate', type: PuzzleType, imageKey: string, locationPoints: Array<{ __typename?: 'Point', latitude: number, longitude: number }>, blocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }> } } | null } };

export type ArchivePuzzleMutationVariables = Exact<{
  puzzleId: Scalars['ID'];
}>;


export type ArchivePuzzleMutation = { __typename?: 'Mutation', archivePuzzle: { __typename?: 'PuzzleResult', errors?: Array<string> | null, puzzle?: { __typename?: 'Puzzle', _id: string, blockingPuzzleIds: Array<string>, expectedAnswer?: string | null, hints: Array<string>, state: PuzzleState, title: string, scoreTiers?: Array<{ __typename?: 'DefaultScoreTier', pointsReward: number } | { __typename?: 'NumberOfMovesScoreTier', numberOfMoves: number, pointsReward: number } | { __typename?: 'NumberOfTriesScoreTier', numberOfTries: number, pointsReward: number } | { __typename?: 'TimedScoreTier', elapsedMinutes: number, pointsReward: number }> | null, submitBlock: { __typename?: 'AugmentedReality', type: SubmitBlockType, anchorImages: Array<{ __typename?: 'AnchorImages', url: string, physicalWidth: number, name: string, hiddenMessage: string }> } | { __typename?: 'AutoPlayingSound', type: SubmitBlockType } | { __typename?: 'ButtonBlock', type: SubmitBlockType, label: string } | { __typename?: 'CameraLayer', type: SubmitBlockType, layerImageUrl: string } | { __typename?: 'Carousel', type: SubmitBlockType, answerImageUrl: string, wrongImageUrls: Array<string>, imagesSize: number } | { __typename?: 'CesarCode', type: SubmitBlockType, stringCode: string, plainText: string } | { __typename?: 'ColorLetters', type: SubmitBlockType, colorLetters: Array<{ __typename?: 'ColorLetter', color: string, letter: string }> } | { __typename?: 'CombinationPadlock', type: SubmitBlockType } | { __typename?: 'Digicode', type: SubmitBlockType } | { __typename?: 'FourDolphins', type: SubmitBlockType } | { __typename?: 'GalerieColbert', type: SubmitBlockType } | { __typename?: 'HideAndSeek', type: SubmitBlockType, hidingImageKey: string, hiddenImageKey: string } | { __typename?: 'ImageAreas', type: SubmitBlockType, numberOfRows: number, numberOfColumns: number, imageKey: string, answerCells: Array<{ __typename?: 'Cell', row: number, column: number }> } | { __typename?: 'ImagesOrdering', type: SubmitBlockType, imageItems: Array<{ __typename?: 'ImagesOrderingItem', imageKey: string, isInitiallyRevealed: boolean, position: number }> } | { __typename?: 'ImagesSelection', type: SubmitBlockType, imageItems: Array<{ __typename?: 'ImagesSelectionItem', imageKey: string, isCorrect: boolean }> } | { __typename?: 'ImagesSorting', type: SubmitBlockType, imageItems: Array<{ __typename?: 'ImagesSortingItem', imageKey: string, position: number }> } | { __typename?: 'InputBlock', type: SubmitBlockType, inputLabel?: string | null, keyboardType?: KeyboardType | null, placeholder?: string | null } | { __typename?: 'LightBulbs', type: SubmitBlockType, imageOnUrl: string, imageOffUrl: string } | { __typename?: 'MorseCode', type: SubmitBlockType, code: string } | { __typename?: 'MultiSelect', type: SubmitBlockType, answerIndices: Array<number>, optionLabels: Array<string> } | { __typename?: 'MusicSheet', type: SubmitBlockType, sequencesToGuess: Array<Array<{ __typename?: 'LetterNote', letter: string, noteIndex: number }>> } | { __typename?: 'Paving', type: SubmitBlockType, numberOfColumns: number, numberOfRows: number, pavingImageKeys: Array<string>, pavingBottonImageKey?: string | null } | { __typename?: 'PhotoPuzzle', type: SubmitBlockType, numberOfColumns: number, numberOfRows: number, photoPuzzleImageKey: string } | { __typename?: 'Rotonde', type: SubmitBlockType } | { __typename?: 'Select', type: SubmitBlockType, options: Array<{ __typename?: 'SelectOption', value: string, label: string }> } | { __typename?: 'SimonSays', type: SubmitBlockType, sequence: Array<number> } | { __typename?: 'Skyline', type: SubmitBlockType, skylineOptions: Array<SkylineOption>, expectedSequence: Array<number> } | { __typename?: 'Sundial', type: SubmitBlockType } | { __typename?: 'WineCellar', type: SubmitBlockType }, template: { __typename?: 'ContentTemplate', type: PuzzleType, blocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }> } | { __typename?: 'HotAndColdTemplate', type: PuzzleType, targetLocation: { __typename?: 'Point', latitude: number, longitude: number }, blocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }> } | { __typename?: 'NavigateAndFindTemplate', type: PuzzleType, imageKey: string, locationPoints: Array<{ __typename?: 'Point', latitude: number, longitude: number }>, blocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }> } } | null } };

export type UpdateScenarioMutationVariables = Exact<{
  scenarioId: Scalars['ID'];
  scenarioUpdateInput: ScenarioUpdateInput;
}>;


export type UpdateScenarioMutation = { __typename?: 'Mutation', updateScenario: { __typename?: 'ScenarioResult', errors?: Array<string> | null, scenario?: { __typename?: 'Scenario', _id: string, accessibility: string, cityId: string, description: string, difficulty: ScenarioDifficulty, distanceEstimate: string, durationEstimate: string, imageKey: string, previewImageKeys: Array<string>, price: number, recommendedHours: string, slug: string, state: ScenarioState, title: string, conclusionBlocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }>, endQuiz: { __typename?: 'Quiz', titleKey: string, questions: Array<{ __typename?: 'Question', expectedAnswerKey: string, labelKey: string, blocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }> }> }, introductionBlocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }>, meta: { __typename?: 'ScenarioMeta', title?: string | null, description?: string | null }, recommendedCommuteStations: Array<{ __typename?: 'CommuteStation', description?: string | null, name: string, commuteLines: { __typename?: 'CommuteLines', metroLines: Array<MetroLine>, rerLines: Array<RerLine> } }> } | null } };

export type CreateScenarioLocationMutationVariables = Exact<{
  scenarioLocationInput: ScenarioLocationInput;
  scenarioId: Scalars['ID'];
}>;


export type CreateScenarioLocationMutation = { __typename?: 'Mutation', createScenarioLocation: { __typename?: 'ScenarioLocationResult', errors?: Array<string> | null, scenarioLocation?: { __typename?: 'ScenarioLocation', _id: string, blockingScenarioLocationIds: Array<string>, imageKey: string, numberOfPuzzles: number, title: string, funFacts: Array<{ __typename?: 'FunFact', title?: string | null, text: string, imageKey?: string | null }>, location: { __typename?: 'Point', latitude: number, longitude: number } } | null } };

export type UpdateScenarioLocationMutationVariables = Exact<{
  scenarioLocationId: Scalars['ID'];
  updateInput: ScenarioLocationInput;
}>;


export type UpdateScenarioLocationMutation = { __typename?: 'Mutation', updateScenarioLocation: { __typename?: 'ScenarioLocationResult', errors?: Array<string> | null, scenarioLocation?: { __typename?: 'ScenarioLocation', _id: string, blockingScenarioLocationIds: Array<string>, imageKey: string, state: ScenarioLocationState, title: string, visitedLandmark?: string | null, funFacts: Array<{ __typename?: 'FunFact', title?: string | null, text: string, imageKey?: string | null }>, location: { __typename?: 'Point', latitude: number, longitude: number } } | null } };

export type ArchiveScenarioLocationMutationVariables = Exact<{
  scenarioLocationId: Scalars['ID'];
}>;


export type ArchiveScenarioLocationMutation = { __typename?: 'Mutation', archiveScenarioLocation: { __typename?: 'ScenarioLocationResult', errors?: Array<string> | null, scenarioLocation?: { __typename?: 'ScenarioLocation', _id: string, blockingScenarioLocationIds: Array<string>, imageKey: string, state: ScenarioLocationState, title: string, visitedLandmark?: string | null, funFacts: Array<{ __typename?: 'FunFact', title?: string | null, text: string, imageKey?: string | null }>, location: { __typename?: 'Point', latitude: number, longitude: number } } | null } };

export type UpdateTranslationsMutationVariables = Exact<{
  archivedTranslationIds: Array<Scalars['String']> | Scalars['String'];
  newTranslations: Array<TranslationCreateInput> | TranslationCreateInput;
  updatedTranslations: Array<TranslationUpdateInput> | TranslationUpdateInput;
}>;


export type UpdateTranslationsMutation = { __typename?: 'Mutation', updateTranslations: Array<{ __typename?: 'Translation', _id: string, key: string, isGlobal: boolean, sectionId: string, french: string, english: string }> };

export type GetBackpackItemsOfScenarioQueryVariables = Exact<{
  scenarioId: Scalars['ID'];
}>;


export type GetBackpackItemsOfScenarioQuery = { __typename?: 'Query', backpackItemsOfScenario: Array<{ __typename?: 'BackpackItem', _id: string, scenarioId: string, blockingScenarioLocationId?: string | null, imageKey: string, state: BackpackItemState, title: string, description: string }> };

export type GetAllCitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCitiesQuery = { __typename?: 'Query', cities: Array<{ __typename?: 'City', _id: string, description: string, imageKey: string, name: string }> };

export type GetCollectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCollectionsQuery = { __typename?: 'Query', collections: Array<{ __typename?: 'Collection', _id: string, areaRadius?: number | null, imageKey: string, name: string, numberOfItems: number, state: CollectionState, type: CollectionType, image: { __typename?: 'Image', aspectRatio: number, caption?: string | null, thumbhash: string, url: string } }> };

export type GetCollectionQueryVariables = Exact<{
  collectionId: Scalars['ID'];
}>;


export type GetCollectionQuery = { __typename?: 'Query', collection: { __typename?: 'Collection', _id: string, areaRadius?: number | null, imageKey: string, name: string, numberOfItems: number, state: CollectionState, type: CollectionType, image: { __typename?: 'Image', aspectRatio: number, caption?: string | null, thumbhash: string, url: string } } };

export type GetItemsOfCollectionQueryVariables = Exact<{
  collectionId: Scalars['ID'];
}>;


export type GetItemsOfCollectionQuery = { __typename?: 'Query', itemsOfCollection: Array<{ __typename?: 'CollectionItem', _id: string, imageKey: string, name: string, fuzzyLocation?: { __typename?: 'Point', latitude: number, longitude: number } | null, image: { __typename?: 'Image', aspectRatio: number, caption?: string | null, thumbhash: string, url: string }, location: { __typename?: 'Point', latitude: number, longitude: number } }> };

export type GetDiscountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDiscountsQuery = { __typename?: 'Query', discounts: Array<{ __typename?: 'Discount', _id: string, amount: number, restrictedUserIds: Array<string>, code: string, state: DiscountState }> };

export type GetGamesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGamesQuery = { __typename?: 'Query', games: Array<{ __typename?: 'Game', _id: string, completedAt?: any | null, createdAt: any, isInDemoMode: boolean, joinCode: string, startedAt?: any | null, state: GameState, scenario: { __typename?: 'Scenario', imageKey: string, title: string }, transaction?: { __typename?: 'Transaction', origin: TransactionOrigin, priceDetails: { __typename?: 'TransactionPrice', total: number, paid: number, discount: number } } | null, user: { __typename?: 'User', email: string, firstName: string, lastName: string } }> };

export type GetGameQueryVariables = Exact<{
  gameId: Scalars['ID'];
}>;


export type GetGameQuery = { __typename?: 'Query', game: { __typename?: 'Game', _id: string, completedAt?: any | null, createdAt: any, isInDemoMode: boolean, joinCode: string, startedAt?: any | null, state: GameState, gameLocations: Array<{ __typename?: 'GameLocation', _id: string, completedAt?: any | null, startedAt?: any | null, state: GameLocationState, gamePuzzles: Array<{ __typename?: 'GamePuzzle', _id: string, completedAt?: any | null, guesses: Array<string | null>, numberOfUsedHints: number, startedAt?: any | null, state: GamePuzzleState, puzzle: { __typename?: 'Puzzle', _id: string, blockingPuzzleIds: Array<string>, title: string } }>, scenarioLocation: { __typename?: 'ScenarioLocation', _id: string, blockingScenarioLocationIds: Array<string>, imageKey: string, title: string } }>, scenario: { __typename?: 'Scenario', imageKey: string, title: string }, transaction?: { __typename?: 'Transaction', origin: TransactionOrigin, priceDetails: { __typename?: 'TransactionPrice', total: number, paid: number, discount: number } } | null, user: { __typename?: 'User', email: string, firstName: string, lastName: string } } };

export type GetImageTranslationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetImageTranslationsQuery = { __typename?: 'Query', imageTranslations: Array<{ __typename?: 'ImageTranslation', _id: string, key: string, isGlobal: boolean, sectionId: string, french: { __typename?: 'Image', aspectRatio: number, caption?: string | null, thumbhash: string, url: string }, english: { __typename?: 'NullableImage', aspectRatio?: number | null, caption?: string | null, thumbhash?: string | null, url?: string | null } }> };

export type GetScenarioLocationPuzzlesQueryVariables = Exact<{
  scenarioLocationId: Scalars['ID'];
}>;


export type GetScenarioLocationPuzzlesQuery = { __typename?: 'Query', scenarioLocationPuzzles: Array<{ __typename?: 'Puzzle', _id: string, blockingPuzzleIds: Array<string>, expectedAnswer?: string | null, hints: Array<string>, state: PuzzleState, title: string, scoreTiers?: Array<{ __typename?: 'DefaultScoreTier', pointsReward: number } | { __typename?: 'NumberOfMovesScoreTier', numberOfMoves: number, pointsReward: number } | { __typename?: 'NumberOfTriesScoreTier', numberOfTries: number, pointsReward: number } | { __typename?: 'TimedScoreTier', elapsedMinutes: number, pointsReward: number }> | null, submitBlock: { __typename?: 'AugmentedReality', type: SubmitBlockType, anchorImages: Array<{ __typename?: 'AnchorImages', url: string, physicalWidth: number, name: string, hiddenMessage: string }> } | { __typename?: 'AutoPlayingSound', type: SubmitBlockType } | { __typename?: 'ButtonBlock', type: SubmitBlockType, label: string } | { __typename?: 'CameraLayer', type: SubmitBlockType, layerImageUrl: string } | { __typename?: 'Carousel', type: SubmitBlockType, answerImageUrl: string, wrongImageUrls: Array<string>, imagesSize: number } | { __typename?: 'CesarCode', type: SubmitBlockType, stringCode: string, plainText: string } | { __typename?: 'ColorLetters', type: SubmitBlockType, colorLetters: Array<{ __typename?: 'ColorLetter', color: string, letter: string }> } | { __typename?: 'CombinationPadlock', type: SubmitBlockType } | { __typename?: 'Digicode', type: SubmitBlockType } | { __typename?: 'FourDolphins', type: SubmitBlockType } | { __typename?: 'GalerieColbert', type: SubmitBlockType } | { __typename?: 'HideAndSeek', type: SubmitBlockType, hidingImageKey: string, hiddenImageKey: string } | { __typename?: 'ImageAreas', type: SubmitBlockType, numberOfRows: number, numberOfColumns: number, imageKey: string, answerCells: Array<{ __typename?: 'Cell', row: number, column: number }> } | { __typename?: 'ImagesOrdering', type: SubmitBlockType, imageItems: Array<{ __typename?: 'ImagesOrderingItem', imageKey: string, isInitiallyRevealed: boolean, position: number }> } | { __typename?: 'ImagesSelection', type: SubmitBlockType, imageItems: Array<{ __typename?: 'ImagesSelectionItem', imageKey: string, isCorrect: boolean }> } | { __typename?: 'ImagesSorting', type: SubmitBlockType, imageItems: Array<{ __typename?: 'ImagesSortingItem', imageKey: string, position: number }> } | { __typename?: 'InputBlock', type: SubmitBlockType, inputLabel?: string | null, keyboardType?: KeyboardType | null, placeholder?: string | null } | { __typename?: 'LightBulbs', type: SubmitBlockType, imageOnUrl: string, imageOffUrl: string } | { __typename?: 'MorseCode', type: SubmitBlockType, code: string } | { __typename?: 'MultiSelect', type: SubmitBlockType, answerIndices: Array<number>, optionLabels: Array<string> } | { __typename?: 'MusicSheet', type: SubmitBlockType, sequencesToGuess: Array<Array<{ __typename?: 'LetterNote', letter: string, noteIndex: number }>> } | { __typename?: 'Paving', type: SubmitBlockType, numberOfColumns: number, numberOfRows: number, pavingImageKeys: Array<string>, pavingBottonImageKey?: string | null } | { __typename?: 'PhotoPuzzle', type: SubmitBlockType, numberOfColumns: number, numberOfRows: number, photoPuzzleImageKey: string } | { __typename?: 'Rotonde', type: SubmitBlockType } | { __typename?: 'Select', type: SubmitBlockType, options: Array<{ __typename?: 'SelectOption', value: string, label: string }> } | { __typename?: 'SimonSays', type: SubmitBlockType, sequence: Array<number> } | { __typename?: 'Skyline', type: SubmitBlockType, skylineOptions: Array<SkylineOption>, expectedSequence: Array<number> } | { __typename?: 'Sundial', type: SubmitBlockType } | { __typename?: 'WineCellar', type: SubmitBlockType }, template: { __typename?: 'ContentTemplate', type: PuzzleType, blocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }> } | { __typename?: 'HotAndColdTemplate', type: PuzzleType, targetLocation: { __typename?: 'Point', latitude: number, longitude: number }, blocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }> } | { __typename?: 'NavigateAndFindTemplate', type: PuzzleType, imageKey: string, locationPoints: Array<{ __typename?: 'Point', latitude: number, longitude: number }>, blocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }> } }> };

export type GetScenariosQueryVariables = Exact<{ [key: string]: never; }>;


export type GetScenariosQuery = { __typename?: 'Query', scenarios: Array<{ __typename?: 'Scenario', _id: string, imageKey: string, price: number, state: ScenarioState, title: string }> };

export type GetScenarioDetailsQueryVariables = Exact<{
  scenarioId: Scalars['ID'];
}>;


export type GetScenarioDetailsQuery = { __typename?: 'Query', scenario: { __typename?: 'Scenario', _id: string, accessibility: string, cityId: string, description: string, difficulty: ScenarioDifficulty, distanceEstimate: string, durationEstimate: string, imageKey: string, previewImageKeys: Array<string>, price: number, recommendedHours: string, slug: string, state: ScenarioState, title: string, landmarks: Array<{ __typename?: 'Landmark', _id: string, imageKey: string, scenarioId: string, state: LandmarkState, title: string, blocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }>, location: { __typename?: 'Point', latitude: number, longitude: number } }>, scenarioLocations: Array<{ __typename?: 'ScenarioLocation', _id: string, blockingScenarioLocationIds: Array<string>, imageKey: string, numberOfPuzzles: number, title: string, funFacts: Array<{ __typename?: 'FunFact', title?: string | null, text: string, imageKey?: string | null }>, location: { __typename?: 'Point', latitude: number, longitude: number } }>, conclusionBlocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }>, endQuiz: { __typename?: 'Quiz', titleKey: string, questions: Array<{ __typename?: 'Question', expectedAnswerKey: string, labelKey: string, blocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }> }> }, introductionBlocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }>, meta: { __typename?: 'ScenarioMeta', title?: string | null, description?: string | null }, recommendedCommuteStations: Array<{ __typename?: 'CommuteStation', description?: string | null, name: string, commuteLines: { __typename?: 'CommuteLines', metroLines: Array<MetroLine>, rerLines: Array<RerLine> } }> } };

export type GetScenarioLocationDetailsQueryVariables = Exact<{
  scenarioLocationId: Scalars['ID'];
}>;


export type GetScenarioLocationDetailsQuery = { __typename?: 'Query', scenarioLocation: { __typename?: 'ScenarioLocation', _id: string, blockingScenarioLocationIds: Array<string>, imageKey: string, state: ScenarioLocationState, title: string, visitedLandmark?: string | null, puzzles: Array<{ __typename?: 'Puzzle', _id: string, blockingPuzzleIds: Array<string>, expectedAnswer?: string | null, hints: Array<string>, state: PuzzleState, title: string, scoreTiers?: Array<{ __typename?: 'DefaultScoreTier', pointsReward: number } | { __typename?: 'NumberOfMovesScoreTier', numberOfMoves: number, pointsReward: number } | { __typename?: 'NumberOfTriesScoreTier', numberOfTries: number, pointsReward: number } | { __typename?: 'TimedScoreTier', elapsedMinutes: number, pointsReward: number }> | null, submitBlock: { __typename?: 'AugmentedReality', type: SubmitBlockType, anchorImages: Array<{ __typename?: 'AnchorImages', url: string, physicalWidth: number, name: string, hiddenMessage: string }> } | { __typename?: 'AutoPlayingSound', type: SubmitBlockType } | { __typename?: 'ButtonBlock', type: SubmitBlockType, label: string } | { __typename?: 'CameraLayer', type: SubmitBlockType, layerImageUrl: string } | { __typename?: 'Carousel', type: SubmitBlockType, answerImageUrl: string, wrongImageUrls: Array<string>, imagesSize: number } | { __typename?: 'CesarCode', type: SubmitBlockType, stringCode: string, plainText: string } | { __typename?: 'ColorLetters', type: SubmitBlockType, colorLetters: Array<{ __typename?: 'ColorLetter', color: string, letter: string }> } | { __typename?: 'CombinationPadlock', type: SubmitBlockType } | { __typename?: 'Digicode', type: SubmitBlockType } | { __typename?: 'FourDolphins', type: SubmitBlockType } | { __typename?: 'GalerieColbert', type: SubmitBlockType } | { __typename?: 'HideAndSeek', type: SubmitBlockType, hidingImageKey: string, hiddenImageKey: string } | { __typename?: 'ImageAreas', type: SubmitBlockType, numberOfRows: number, numberOfColumns: number, imageKey: string, answerCells: Array<{ __typename?: 'Cell', row: number, column: number }> } | { __typename?: 'ImagesOrdering', type: SubmitBlockType, imageItems: Array<{ __typename?: 'ImagesOrderingItem', imageKey: string, isInitiallyRevealed: boolean, position: number }> } | { __typename?: 'ImagesSelection', type: SubmitBlockType, imageItems: Array<{ __typename?: 'ImagesSelectionItem', imageKey: string, isCorrect: boolean }> } | { __typename?: 'ImagesSorting', type: SubmitBlockType, imageItems: Array<{ __typename?: 'ImagesSortingItem', imageKey: string, position: number }> } | { __typename?: 'InputBlock', type: SubmitBlockType, inputLabel?: string | null, keyboardType?: KeyboardType | null, placeholder?: string | null } | { __typename?: 'LightBulbs', type: SubmitBlockType, imageOnUrl: string, imageOffUrl: string } | { __typename?: 'MorseCode', type: SubmitBlockType, code: string } | { __typename?: 'MultiSelect', type: SubmitBlockType, answerIndices: Array<number>, optionLabels: Array<string> } | { __typename?: 'MusicSheet', type: SubmitBlockType, sequencesToGuess: Array<Array<{ __typename?: 'LetterNote', letter: string, noteIndex: number }>> } | { __typename?: 'Paving', type: SubmitBlockType, numberOfColumns: number, numberOfRows: number, pavingImageKeys: Array<string>, pavingBottonImageKey?: string | null } | { __typename?: 'PhotoPuzzle', type: SubmitBlockType, numberOfColumns: number, numberOfRows: number, photoPuzzleImageKey: string } | { __typename?: 'Rotonde', type: SubmitBlockType } | { __typename?: 'Select', type: SubmitBlockType, options: Array<{ __typename?: 'SelectOption', value: string, label: string }> } | { __typename?: 'SimonSays', type: SubmitBlockType, sequence: Array<number> } | { __typename?: 'Skyline', type: SubmitBlockType, skylineOptions: Array<SkylineOption>, expectedSequence: Array<number> } | { __typename?: 'Sundial', type: SubmitBlockType } | { __typename?: 'WineCellar', type: SubmitBlockType }, template: { __typename?: 'ContentTemplate', type: PuzzleType, blocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }> } | { __typename?: 'HotAndColdTemplate', type: PuzzleType, targetLocation: { __typename?: 'Point', latitude: number, longitude: number }, blocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }> } | { __typename?: 'NavigateAndFindTemplate', type: PuzzleType, imageKey: string, locationPoints: Array<{ __typename?: 'Point', latitude: number, longitude: number }>, blocks: Array<{ __typename?: 'EquationsBlock', type: ContentBlockType, equations: Array<string> } | { __typename?: 'ImageBlock', type: ContentBlockType, imageKey: string } | { __typename?: 'ParagraphBlock', type: ContentBlockType, text: string } | { __typename?: 'SubtitleBlock', type: ContentBlockType, text: string } | { __typename?: 'TitleBlock', type: ContentBlockType, text: string }> } }>, sameScenarioLocations: Array<{ __typename?: 'ScenarioLocation', _id: string, title: string }>, funFacts: Array<{ __typename?: 'FunFact', title?: string | null, text: string, imageKey?: string | null }>, location: { __typename?: 'Point', latitude: number, longitude: number } } };

export type GetTranslationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTranslationsQuery = { __typename?: 'Query', translations: Array<{ __typename?: 'Translation', _id: string, key: string, isGlobal: boolean, sectionId: string, french: string, english: string }> };

export type GetUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', _id: string, deviceId?: string | null, email: string, firstName: string, lastName: string, stripeCustomerId?: string | null }> };

export const BackpackItemFragmentDoc = gql`
    fragment BackpackItem on BackpackItem {
  _id
  scenarioId
  blockingScenarioLocationId
  imageKey
  state
  title
  description
}
    `;
export const ImageFragmentDoc = gql`
    fragment Image on Image {
  aspectRatio
  caption
  thumbhash
  url
}
    `;
export const CollectionFragmentDoc = gql`
    fragment Collection on Collection {
  _id
  areaRadius
  image {
    ...Image
  }
  imageKey
  name
  numberOfItems
  state
  type
}
    ${ImageFragmentDoc}`;
export const CollectionItemFragmentDoc = gql`
    fragment CollectionItem on CollectionItem {
  _id
  fuzzyLocation {
    latitude
    longitude
  }
  image {
    ...Image
  }
  imageKey
  location {
    latitude
    longitude
  }
  name
}
    ${ImageFragmentDoc}`;
export const GamePuzzleFragmentDoc = gql`
    fragment GamePuzzle on GamePuzzle {
  _id
  completedAt
  guesses
  numberOfUsedHints
  puzzle {
    _id
    blockingPuzzleIds
    title
  }
  startedAt
  state
}
    `;
export const GameLocationFragmentDoc = gql`
    fragment GameLocation on GameLocation {
  _id
  completedAt
  gamePuzzles {
    ...GamePuzzle
  }
  scenarioLocation {
    _id
    blockingScenarioLocationIds
    imageKey
    title
  }
  startedAt
  state
}
    ${GamePuzzleFragmentDoc}`;
export const GameFragmentDoc = gql`
    fragment Game on Game {
  _id
  completedAt
  createdAt
  gameLocations {
    ...GameLocation
  }
  isInDemoMode
  joinCode
  scenario {
    imageKey
    title
  }
  startedAt
  state
  transaction {
    origin
    priceDetails {
      total
      paid
      discount
    }
  }
  user {
    email
    firstName
    lastName
  }
}
    ${GameLocationFragmentDoc}`;
export const NullableImageFragmentDoc = gql`
    fragment NullableImage on NullableImage {
  aspectRatio
  caption
  thumbhash
  url
}
    `;
export const ImageTranslationFragmentDoc = gql`
    fragment ImageTranslation on ImageTranslation {
  _id
  key
  isGlobal
  sectionId
  french {
    ...Image
  }
  english {
    ...NullableImage
  }
}
    ${ImageFragmentDoc}
${NullableImageFragmentDoc}`;
export const ContentBlockFragmentDoc = gql`
    fragment ContentBlock on ContentBlock {
  ... on TitleBlock {
    type
    text
  }
  ... on SubtitleBlock {
    type
    text
  }
  ... on ParagraphBlock {
    type
    text
  }
  ... on ImageBlock {
    type
    imageKey
  }
  ... on EquationsBlock {
    type
    equations
  }
}
    `;
export const LandmarkFragmentDoc = gql`
    fragment Landmark on Landmark {
  _id
  blocks {
    ...ContentBlock
  }
  imageKey
  location {
    latitude
    longitude
  }
  scenarioId
  state
  title
}
    ${ContentBlockFragmentDoc}`;
export const ScoreTierFragmentDoc = gql`
    fragment ScoreTier on ScoreTier {
  ... on NumberOfTriesScoreTier {
    numberOfTries
    pointsReward
  }
  ... on NumberOfMovesScoreTier {
    numberOfMoves
    pointsReward
  }
  ... on TimedScoreTier {
    elapsedMinutes
    pointsReward
  }
  ... on DefaultScoreTier {
    pointsReward
  }
}
    `;
export const SubmitBlockFragmentDoc = gql`
    fragment SubmitBlock on SubmitBlock {
  ... on AugmentedReality {
    type
    anchorImages {
      url
      physicalWidth
      name
      hiddenMessage
    }
  }
  ... on AutoPlayingSound {
    type
  }
  ... on ButtonBlock {
    type
    label
  }
  ... on CameraLayer {
    type
    layerImageUrl
  }
  ... on Carousel {
    type
    answerImageUrl
    wrongImageUrls
    imagesSize
  }
  ... on CesarCode {
    type
    stringCode
    plainText
  }
  ... on ColorLetters {
    type
    colorLetters {
      color
      letter
    }
  }
  ... on CombinationPadlock {
    type
  }
  ... on Digicode {
    type
  }
  ... on FourDolphins {
    type
  }
  ... on GalerieColbert {
    type
  }
  ... on HideAndSeek {
    type
    hidingImageKey
    hiddenImageKey
  }
  ... on ImageAreas {
    type
    numberOfRows
    numberOfColumns
    imageKey
    answerCells {
      row
      column
    }
  }
  ... on ImagesOrdering {
    type
    imageItems {
      imageKey
      isInitiallyRevealed
      position
    }
  }
  ... on ImagesSelection {
    type
    imageItems {
      imageKey
      isCorrect
    }
  }
  ... on ImagesSorting {
    type
    imageItems {
      imageKey
      position
    }
  }
  ... on InputBlock {
    type
    inputLabel
    keyboardType
    placeholder
  }
  ... on LightBulbs {
    type
    imageOnUrl
    imageOffUrl
  }
  ... on MorseCode {
    type
    code
  }
  ... on MultiSelect {
    type
    answerIndices
    optionLabels
  }
  ... on MusicSheet {
    type
    sequencesToGuess {
      letter
      noteIndex
    }
  }
  ... on Paving {
    type
    numberOfColumns
    numberOfRows
    pavingImageKeys
    pavingBottonImageKey
  }
  ... on PhotoPuzzle {
    type
    numberOfColumns
    numberOfRows
    photoPuzzleImageKey
  }
  ... on Rotonde {
    type
  }
  ... on Select {
    type
    options {
      value
      label
    }
  }
  ... on SimonSays {
    type
    sequence
  }
  ... on Skyline {
    type
    skylineOptions
    expectedSequence
  }
  ... on Sundial {
    type
  }
  ... on WineCellar {
    type
  }
}
    `;
export const PuzzleTemplateFragmentDoc = gql`
    fragment PuzzleTemplate on PuzzleTemplate {
  ... on ContentTemplate {
    type
    blocks {
      ...ContentBlock
    }
  }
  ... on HotAndColdTemplate {
    type
    targetLocation {
      latitude
      longitude
    }
    blocks {
      ...ContentBlock
    }
  }
  ... on NavigateAndFindTemplate {
    type
    imageKey
    locationPoints {
      latitude
      longitude
    }
    blocks {
      ...ContentBlock
    }
  }
}
    ${ContentBlockFragmentDoc}`;
export const PuzzleFragmentDoc = gql`
    fragment Puzzle on Puzzle {
  _id
  blockingPuzzleIds
  expectedAnswer
  hints
  scoreTiers {
    ...ScoreTier
  }
  state
  submitBlock {
    ...SubmitBlock
  }
  template {
    ...PuzzleTemplate
  }
  title
}
    ${ScoreTierFragmentDoc}
${SubmitBlockFragmentDoc}
${PuzzleTemplateFragmentDoc}`;
export const QuizFragmentDoc = gql`
    fragment Quiz on Quiz {
  questions {
    blocks {
      ...ContentBlock
    }
    expectedAnswerKey
    labelKey
  }
  titleKey
}
    ${ContentBlockFragmentDoc}`;
export const ScenarioFragmentDoc = gql`
    fragment Scenario on Scenario {
  _id
  accessibility
  cityId
  conclusionBlocks {
    ...ContentBlock
  }
  description
  difficulty
  distanceEstimate
  durationEstimate
  endQuiz {
    ...Quiz
  }
  introductionBlocks {
    ...ContentBlock
  }
  imageKey
  meta {
    title
    description
  }
  previewImageKeys
  price
  recommendedCommuteStations {
    description
    commuteLines {
      metroLines
      rerLines
    }
    name
  }
  recommendedHours
  slug
  state
  title
}
    ${ContentBlockFragmentDoc}
${QuizFragmentDoc}`;
export const FunFactFragmentDoc = gql`
    fragment FunFact on FunFact {
  title
  text
  imageKey
}
    `;
export const ScenarioLocationFragmentDoc = gql`
    fragment ScenarioLocation on ScenarioLocation {
  _id
  blockingScenarioLocationIds
  funFacts {
    ...FunFact
  }
  imageKey
  location {
    latitude
    longitude
  }
  state
  title
  visitedLandmark
}
    ${FunFactFragmentDoc}`;
export const ScenarioLocationOfScenarioFragmentDoc = gql`
    fragment ScenarioLocationOfScenario on ScenarioLocation {
  _id
  blockingScenarioLocationIds
  funFacts {
    ...FunFact
  }
  imageKey
  location {
    latitude
    longitude
  }
  numberOfPuzzles
  title
}
    ${FunFactFragmentDoc}`;
export const TranslationFragmentDoc = gql`
    fragment Translation on Translation {
  _id
  key
  isGlobal
  sectionId
  french
  english
}
    `;
export const LoginAdminDocument = gql`
    mutation loginAdmin($email: String!, $password: String!) {
  loginAdmin(email: $email, password: $password) {
    ... on ErrorAuthenticationInfo {
      success
      error
    }
    ... on SuccessAuthenticationInfo {
      success
      token
      admin {
        _id
        email
      }
    }
  }
}
    `;
export type LoginAdminMutationFn = Apollo.MutationFunction<LoginAdminMutation, LoginAdminMutationVariables>;

/**
 * __useLoginAdminMutation__
 *
 * To run a mutation, you first call `useLoginAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginAdminMutation, { data, loading, error }] = useLoginAdminMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginAdminMutation(baseOptions?: Apollo.MutationHookOptions<LoginAdminMutation, LoginAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginAdminMutation, LoginAdminMutationVariables>(LoginAdminDocument, options);
      }
export type LoginAdminMutationHookResult = ReturnType<typeof useLoginAdminMutation>;
export type LoginAdminMutationResult = Apollo.MutationResult<LoginAdminMutation>;
export type LoginAdminMutationOptions = Apollo.BaseMutationOptions<LoginAdminMutation, LoginAdminMutationVariables>;
export const VerifyTokenDocument = gql`
    mutation verifyToken {
  verifyToken {
    admin {
      _id
      email
    }
  }
}
    `;
export type VerifyTokenMutationFn = Apollo.MutationFunction<VerifyTokenMutation, VerifyTokenMutationVariables>;

/**
 * __useVerifyTokenMutation__
 *
 * To run a mutation, you first call `useVerifyTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyTokenMutation, { data, loading, error }] = useVerifyTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useVerifyTokenMutation(baseOptions?: Apollo.MutationHookOptions<VerifyTokenMutation, VerifyTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyTokenMutation, VerifyTokenMutationVariables>(VerifyTokenDocument, options);
      }
export type VerifyTokenMutationHookResult = ReturnType<typeof useVerifyTokenMutation>;
export type VerifyTokenMutationResult = Apollo.MutationResult<VerifyTokenMutation>;
export type VerifyTokenMutationOptions = Apollo.BaseMutationOptions<VerifyTokenMutation, VerifyTokenMutationVariables>;
export const CreateBackpackItemDocument = gql`
    mutation createBackpackItem($backpackItemInput: BackpackItemInput!, $scenarioId: ID!) {
  createBackpackItem(
    backpackItemInput: $backpackItemInput
    scenarioId: $scenarioId
  ) {
    errors
    backpackItem {
      ...BackpackItem
    }
  }
}
    ${BackpackItemFragmentDoc}`;
export type CreateBackpackItemMutationFn = Apollo.MutationFunction<CreateBackpackItemMutation, CreateBackpackItemMutationVariables>;

/**
 * __useCreateBackpackItemMutation__
 *
 * To run a mutation, you first call `useCreateBackpackItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBackpackItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBackpackItemMutation, { data, loading, error }] = useCreateBackpackItemMutation({
 *   variables: {
 *      backpackItemInput: // value for 'backpackItemInput'
 *      scenarioId: // value for 'scenarioId'
 *   },
 * });
 */
export function useCreateBackpackItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateBackpackItemMutation, CreateBackpackItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBackpackItemMutation, CreateBackpackItemMutationVariables>(CreateBackpackItemDocument, options);
      }
export type CreateBackpackItemMutationHookResult = ReturnType<typeof useCreateBackpackItemMutation>;
export type CreateBackpackItemMutationResult = Apollo.MutationResult<CreateBackpackItemMutation>;
export type CreateBackpackItemMutationOptions = Apollo.BaseMutationOptions<CreateBackpackItemMutation, CreateBackpackItemMutationVariables>;
export const UpdateBackpackItemDocument = gql`
    mutation updateBackpackItem($backpackItemId: ID!, $updateInput: BackpackItemInput!) {
  updateBackpackItem(backpackItemId: $backpackItemId, updateInput: $updateInput) {
    errors
    backpackItem {
      ...BackpackItem
    }
  }
}
    ${BackpackItemFragmentDoc}`;
export type UpdateBackpackItemMutationFn = Apollo.MutationFunction<UpdateBackpackItemMutation, UpdateBackpackItemMutationVariables>;

/**
 * __useUpdateBackpackItemMutation__
 *
 * To run a mutation, you first call `useUpdateBackpackItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBackpackItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBackpackItemMutation, { data, loading, error }] = useUpdateBackpackItemMutation({
 *   variables: {
 *      backpackItemId: // value for 'backpackItemId'
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateBackpackItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBackpackItemMutation, UpdateBackpackItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBackpackItemMutation, UpdateBackpackItemMutationVariables>(UpdateBackpackItemDocument, options);
      }
export type UpdateBackpackItemMutationHookResult = ReturnType<typeof useUpdateBackpackItemMutation>;
export type UpdateBackpackItemMutationResult = Apollo.MutationResult<UpdateBackpackItemMutation>;
export type UpdateBackpackItemMutationOptions = Apollo.BaseMutationOptions<UpdateBackpackItemMutation, UpdateBackpackItemMutationVariables>;
export const ArchiveBackpackItemDocument = gql`
    mutation archiveBackpackItem($backpackItemId: ID!) {
  archiveBackpackItem(backpackItemId: $backpackItemId) {
    errors
    backpackItem {
      ...BackpackItem
    }
  }
}
    ${BackpackItemFragmentDoc}`;
export type ArchiveBackpackItemMutationFn = Apollo.MutationFunction<ArchiveBackpackItemMutation, ArchiveBackpackItemMutationVariables>;

/**
 * __useArchiveBackpackItemMutation__
 *
 * To run a mutation, you first call `useArchiveBackpackItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveBackpackItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveBackpackItemMutation, { data, loading, error }] = useArchiveBackpackItemMutation({
 *   variables: {
 *      backpackItemId: // value for 'backpackItemId'
 *   },
 * });
 */
export function useArchiveBackpackItemMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveBackpackItemMutation, ArchiveBackpackItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveBackpackItemMutation, ArchiveBackpackItemMutationVariables>(ArchiveBackpackItemDocument, options);
      }
export type ArchiveBackpackItemMutationHookResult = ReturnType<typeof useArchiveBackpackItemMutation>;
export type ArchiveBackpackItemMutationResult = Apollo.MutationResult<ArchiveBackpackItemMutation>;
export type ArchiveBackpackItemMutationOptions = Apollo.BaseMutationOptions<ArchiveBackpackItemMutation, ArchiveBackpackItemMutationVariables>;
export const CreateCollectionItemDocument = gql`
    mutation createCollectionItem($collectionId: ID!, $collectionItemInput: CreateCollectionItemInput!) {
  createCollectionItem(
    collectionId: $collectionId
    collectionItemInput: $collectionItemInput
  ) {
    errors
    collectionItem {
      ...CollectionItem
    }
  }
}
    ${CollectionItemFragmentDoc}`;
export type CreateCollectionItemMutationFn = Apollo.MutationFunction<CreateCollectionItemMutation, CreateCollectionItemMutationVariables>;

/**
 * __useCreateCollectionItemMutation__
 *
 * To run a mutation, you first call `useCreateCollectionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCollectionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCollectionItemMutation, { data, loading, error }] = useCreateCollectionItemMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      collectionItemInput: // value for 'collectionItemInput'
 *   },
 * });
 */
export function useCreateCollectionItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateCollectionItemMutation, CreateCollectionItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCollectionItemMutation, CreateCollectionItemMutationVariables>(CreateCollectionItemDocument, options);
      }
export type CreateCollectionItemMutationHookResult = ReturnType<typeof useCreateCollectionItemMutation>;
export type CreateCollectionItemMutationResult = Apollo.MutationResult<CreateCollectionItemMutation>;
export type CreateCollectionItemMutationOptions = Apollo.BaseMutationOptions<CreateCollectionItemMutation, CreateCollectionItemMutationVariables>;
export const CreateGameDocument = gql`
    mutation createGame($firstName: String!, $lastName: String!, $language: Language!, $email: String!, $scenarioId: ID!) {
  createGame(
    firstName: $firstName
    lastName: $lastName
    language: $language
    email: $email
    scenarioId: $scenarioId
  ) {
    game {
      ...Game
    }
  }
}
    ${GameFragmentDoc}`;
export type CreateGameMutationFn = Apollo.MutationFunction<CreateGameMutation, CreateGameMutationVariables>;

/**
 * __useCreateGameMutation__
 *
 * To run a mutation, you first call `useCreateGameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGameMutation, { data, loading, error }] = useCreateGameMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      language: // value for 'language'
 *      email: // value for 'email'
 *      scenarioId: // value for 'scenarioId'
 *   },
 * });
 */
export function useCreateGameMutation(baseOptions?: Apollo.MutationHookOptions<CreateGameMutation, CreateGameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGameMutation, CreateGameMutationVariables>(CreateGameDocument, options);
      }
export type CreateGameMutationHookResult = ReturnType<typeof useCreateGameMutation>;
export type CreateGameMutationResult = Apollo.MutationResult<CreateGameMutation>;
export type CreateGameMutationOptions = Apollo.BaseMutationOptions<CreateGameMutation, CreateGameMutationVariables>;
export const UpdateGamePuzzleStateDocument = gql`
    mutation updateGamePuzzleState($gamePuzzleId: ID!, $state: GamePuzzleState!) {
  updateGamePuzzleState(gamePuzzleId: $gamePuzzleId, state: $state) {
    _id
    gameLocations {
      _id
      completedAt
      gamePuzzles {
        _id
        completedAt
        state
      }
      state
    }
    state
  }
}
    `;
export type UpdateGamePuzzleStateMutationFn = Apollo.MutationFunction<UpdateGamePuzzleStateMutation, UpdateGamePuzzleStateMutationVariables>;

/**
 * __useUpdateGamePuzzleStateMutation__
 *
 * To run a mutation, you first call `useUpdateGamePuzzleStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGamePuzzleStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGamePuzzleStateMutation, { data, loading, error }] = useUpdateGamePuzzleStateMutation({
 *   variables: {
 *      gamePuzzleId: // value for 'gamePuzzleId'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useUpdateGamePuzzleStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGamePuzzleStateMutation, UpdateGamePuzzleStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGamePuzzleStateMutation, UpdateGamePuzzleStateMutationVariables>(UpdateGamePuzzleStateDocument, options);
      }
export type UpdateGamePuzzleStateMutationHookResult = ReturnType<typeof useUpdateGamePuzzleStateMutation>;
export type UpdateGamePuzzleStateMutationResult = Apollo.MutationResult<UpdateGamePuzzleStateMutation>;
export type UpdateGamePuzzleStateMutationOptions = Apollo.BaseMutationOptions<UpdateGamePuzzleStateMutation, UpdateGamePuzzleStateMutationVariables>;
export const UpdateImageTranslationsDocument = gql`
    mutation updateImageTranslations($archivedImageTranslationIds: [ID!]!, $newImageTranslations: [ImageTranslationCreateInput!]!, $updatedImageTranslations: [ImageTranslationUpdateInput!]!) {
  updateImageTranslations(
    archivedImageTranslationIds: $archivedImageTranslationIds
    newImageTranslations: $newImageTranslations
    updatedImageTranslations: $updatedImageTranslations
  ) {
    errors
    imageTranslations {
      ...ImageTranslation
    }
  }
}
    ${ImageTranslationFragmentDoc}`;
export type UpdateImageTranslationsMutationFn = Apollo.MutationFunction<UpdateImageTranslationsMutation, UpdateImageTranslationsMutationVariables>;

/**
 * __useUpdateImageTranslationsMutation__
 *
 * To run a mutation, you first call `useUpdateImageTranslationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImageTranslationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImageTranslationsMutation, { data, loading, error }] = useUpdateImageTranslationsMutation({
 *   variables: {
 *      archivedImageTranslationIds: // value for 'archivedImageTranslationIds'
 *      newImageTranslations: // value for 'newImageTranslations'
 *      updatedImageTranslations: // value for 'updatedImageTranslations'
 *   },
 * });
 */
export function useUpdateImageTranslationsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateImageTranslationsMutation, UpdateImageTranslationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateImageTranslationsMutation, UpdateImageTranslationsMutationVariables>(UpdateImageTranslationsDocument, options);
      }
export type UpdateImageTranslationsMutationHookResult = ReturnType<typeof useUpdateImageTranslationsMutation>;
export type UpdateImageTranslationsMutationResult = Apollo.MutationResult<UpdateImageTranslationsMutation>;
export type UpdateImageTranslationsMutationOptions = Apollo.BaseMutationOptions<UpdateImageTranslationsMutation, UpdateImageTranslationsMutationVariables>;
export const ArchiveLandmarkDocument = gql`
    mutation archiveLandmark($landmarkId: ID!) {
  archiveLandmark(landmarkId: $landmarkId) {
    errors
    landmark {
      ...Landmark
    }
  }
}
    ${LandmarkFragmentDoc}`;
export type ArchiveLandmarkMutationFn = Apollo.MutationFunction<ArchiveLandmarkMutation, ArchiveLandmarkMutationVariables>;

/**
 * __useArchiveLandmarkMutation__
 *
 * To run a mutation, you first call `useArchiveLandmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveLandmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveLandmarkMutation, { data, loading, error }] = useArchiveLandmarkMutation({
 *   variables: {
 *      landmarkId: // value for 'landmarkId'
 *   },
 * });
 */
export function useArchiveLandmarkMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveLandmarkMutation, ArchiveLandmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveLandmarkMutation, ArchiveLandmarkMutationVariables>(ArchiveLandmarkDocument, options);
      }
export type ArchiveLandmarkMutationHookResult = ReturnType<typeof useArchiveLandmarkMutation>;
export type ArchiveLandmarkMutationResult = Apollo.MutationResult<ArchiveLandmarkMutation>;
export type ArchiveLandmarkMutationOptions = Apollo.BaseMutationOptions<ArchiveLandmarkMutation, ArchiveLandmarkMutationVariables>;
export const CreateLandmarkDocument = gql`
    mutation createLandmark($landmarkInput: LandmarkInput!) {
  createLandmark(landmarkInput: $landmarkInput) {
    errors
    landmark {
      ...Landmark
    }
  }
}
    ${LandmarkFragmentDoc}`;
export type CreateLandmarkMutationFn = Apollo.MutationFunction<CreateLandmarkMutation, CreateLandmarkMutationVariables>;

/**
 * __useCreateLandmarkMutation__
 *
 * To run a mutation, you first call `useCreateLandmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLandmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLandmarkMutation, { data, loading, error }] = useCreateLandmarkMutation({
 *   variables: {
 *      landmarkInput: // value for 'landmarkInput'
 *   },
 * });
 */
export function useCreateLandmarkMutation(baseOptions?: Apollo.MutationHookOptions<CreateLandmarkMutation, CreateLandmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLandmarkMutation, CreateLandmarkMutationVariables>(CreateLandmarkDocument, options);
      }
export type CreateLandmarkMutationHookResult = ReturnType<typeof useCreateLandmarkMutation>;
export type CreateLandmarkMutationResult = Apollo.MutationResult<CreateLandmarkMutation>;
export type CreateLandmarkMutationOptions = Apollo.BaseMutationOptions<CreateLandmarkMutation, CreateLandmarkMutationVariables>;
export const UpdateLandmarkDocument = gql`
    mutation updateLandmark($landmarkId: ID!, $updateInput: LandmarkUpdateInput!) {
  updateLandmark(landmarkId: $landmarkId, updateInput: $updateInput) {
    errors
    landmark {
      ...Landmark
    }
  }
}
    ${LandmarkFragmentDoc}`;
export type UpdateLandmarkMutationFn = Apollo.MutationFunction<UpdateLandmarkMutation, UpdateLandmarkMutationVariables>;

/**
 * __useUpdateLandmarkMutation__
 *
 * To run a mutation, you first call `useUpdateLandmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLandmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLandmarkMutation, { data, loading, error }] = useUpdateLandmarkMutation({
 *   variables: {
 *      landmarkId: // value for 'landmarkId'
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateLandmarkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLandmarkMutation, UpdateLandmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLandmarkMutation, UpdateLandmarkMutationVariables>(UpdateLandmarkDocument, options);
      }
export type UpdateLandmarkMutationHookResult = ReturnType<typeof useUpdateLandmarkMutation>;
export type UpdateLandmarkMutationResult = Apollo.MutationResult<UpdateLandmarkMutation>;
export type UpdateLandmarkMutationOptions = Apollo.BaseMutationOptions<UpdateLandmarkMutation, UpdateLandmarkMutationVariables>;
export const UpdateLandmarksLocationsDocument = gql`
    mutation updateLandmarksLocations($landmarkIdsAndLocations: [LandmarkIdAndLocationInput!]!) {
  updateLandmarksLocations(landmarkIdsAndLocations: $landmarkIdsAndLocations) {
    errors
    landmarks {
      ...Landmark
    }
  }
}
    ${LandmarkFragmentDoc}`;
export type UpdateLandmarksLocationsMutationFn = Apollo.MutationFunction<UpdateLandmarksLocationsMutation, UpdateLandmarksLocationsMutationVariables>;

/**
 * __useUpdateLandmarksLocationsMutation__
 *
 * To run a mutation, you first call `useUpdateLandmarksLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLandmarksLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLandmarksLocationsMutation, { data, loading, error }] = useUpdateLandmarksLocationsMutation({
 *   variables: {
 *      landmarkIdsAndLocations: // value for 'landmarkIdsAndLocations'
 *   },
 * });
 */
export function useUpdateLandmarksLocationsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLandmarksLocationsMutation, UpdateLandmarksLocationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLandmarksLocationsMutation, UpdateLandmarksLocationsMutationVariables>(UpdateLandmarksLocationsDocument, options);
      }
export type UpdateLandmarksLocationsMutationHookResult = ReturnType<typeof useUpdateLandmarksLocationsMutation>;
export type UpdateLandmarksLocationsMutationResult = Apollo.MutationResult<UpdateLandmarksLocationsMutation>;
export type UpdateLandmarksLocationsMutationOptions = Apollo.BaseMutationOptions<UpdateLandmarksLocationsMutation, UpdateLandmarksLocationsMutationVariables>;
export const CreatePuzzleDocument = gql`
    mutation createPuzzle($puzzleInput: CreatePuzzleInput!) {
  createPuzzle(puzzleInput: $puzzleInput) {
    errors
    puzzle {
      ...Puzzle
    }
  }
}
    ${PuzzleFragmentDoc}`;
export type CreatePuzzleMutationFn = Apollo.MutationFunction<CreatePuzzleMutation, CreatePuzzleMutationVariables>;

/**
 * __useCreatePuzzleMutation__
 *
 * To run a mutation, you first call `useCreatePuzzleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePuzzleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPuzzleMutation, { data, loading, error }] = useCreatePuzzleMutation({
 *   variables: {
 *      puzzleInput: // value for 'puzzleInput'
 *   },
 * });
 */
export function useCreatePuzzleMutation(baseOptions?: Apollo.MutationHookOptions<CreatePuzzleMutation, CreatePuzzleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePuzzleMutation, CreatePuzzleMutationVariables>(CreatePuzzleDocument, options);
      }
export type CreatePuzzleMutationHookResult = ReturnType<typeof useCreatePuzzleMutation>;
export type CreatePuzzleMutationResult = Apollo.MutationResult<CreatePuzzleMutation>;
export type CreatePuzzleMutationOptions = Apollo.BaseMutationOptions<CreatePuzzleMutation, CreatePuzzleMutationVariables>;
export const UpdatePuzzleDocument = gql`
    mutation updatePuzzle($puzzleId: ID!, $updateInput: PuzzleUpdateInput!) {
  updatePuzzle(puzzleId: $puzzleId, updateInput: $updateInput) {
    errors
    puzzle {
      ...Puzzle
    }
  }
}
    ${PuzzleFragmentDoc}`;
export type UpdatePuzzleMutationFn = Apollo.MutationFunction<UpdatePuzzleMutation, UpdatePuzzleMutationVariables>;

/**
 * __useUpdatePuzzleMutation__
 *
 * To run a mutation, you first call `useUpdatePuzzleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePuzzleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePuzzleMutation, { data, loading, error }] = useUpdatePuzzleMutation({
 *   variables: {
 *      puzzleId: // value for 'puzzleId'
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdatePuzzleMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePuzzleMutation, UpdatePuzzleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePuzzleMutation, UpdatePuzzleMutationVariables>(UpdatePuzzleDocument, options);
      }
export type UpdatePuzzleMutationHookResult = ReturnType<typeof useUpdatePuzzleMutation>;
export type UpdatePuzzleMutationResult = Apollo.MutationResult<UpdatePuzzleMutation>;
export type UpdatePuzzleMutationOptions = Apollo.BaseMutationOptions<UpdatePuzzleMutation, UpdatePuzzleMutationVariables>;
export const ArchivePuzzleDocument = gql`
    mutation archivePuzzle($puzzleId: ID!) {
  archivePuzzle(puzzleId: $puzzleId) {
    errors
    puzzle {
      ...Puzzle
    }
  }
}
    ${PuzzleFragmentDoc}`;
export type ArchivePuzzleMutationFn = Apollo.MutationFunction<ArchivePuzzleMutation, ArchivePuzzleMutationVariables>;

/**
 * __useArchivePuzzleMutation__
 *
 * To run a mutation, you first call `useArchivePuzzleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchivePuzzleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archivePuzzleMutation, { data, loading, error }] = useArchivePuzzleMutation({
 *   variables: {
 *      puzzleId: // value for 'puzzleId'
 *   },
 * });
 */
export function useArchivePuzzleMutation(baseOptions?: Apollo.MutationHookOptions<ArchivePuzzleMutation, ArchivePuzzleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchivePuzzleMutation, ArchivePuzzleMutationVariables>(ArchivePuzzleDocument, options);
      }
export type ArchivePuzzleMutationHookResult = ReturnType<typeof useArchivePuzzleMutation>;
export type ArchivePuzzleMutationResult = Apollo.MutationResult<ArchivePuzzleMutation>;
export type ArchivePuzzleMutationOptions = Apollo.BaseMutationOptions<ArchivePuzzleMutation, ArchivePuzzleMutationVariables>;
export const UpdateScenarioDocument = gql`
    mutation UPDATE_SCENARIO($scenarioId: ID!, $scenarioUpdateInput: ScenarioUpdateInput!) {
  updateScenario(
    scenarioId: $scenarioId
    scenarioUpdateInput: $scenarioUpdateInput
  ) {
    errors
    scenario {
      ...Scenario
    }
  }
}
    ${ScenarioFragmentDoc}`;
export type UpdateScenarioMutationFn = Apollo.MutationFunction<UpdateScenarioMutation, UpdateScenarioMutationVariables>;

/**
 * __useUpdateScenarioMutation__
 *
 * To run a mutation, you first call `useUpdateScenarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScenarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScenarioMutation, { data, loading, error }] = useUpdateScenarioMutation({
 *   variables: {
 *      scenarioId: // value for 'scenarioId'
 *      scenarioUpdateInput: // value for 'scenarioUpdateInput'
 *   },
 * });
 */
export function useUpdateScenarioMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScenarioMutation, UpdateScenarioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScenarioMutation, UpdateScenarioMutationVariables>(UpdateScenarioDocument, options);
      }
export type UpdateScenarioMutationHookResult = ReturnType<typeof useUpdateScenarioMutation>;
export type UpdateScenarioMutationResult = Apollo.MutationResult<UpdateScenarioMutation>;
export type UpdateScenarioMutationOptions = Apollo.BaseMutationOptions<UpdateScenarioMutation, UpdateScenarioMutationVariables>;
export const CreateScenarioLocationDocument = gql`
    mutation createScenarioLocation($scenarioLocationInput: ScenarioLocationInput!, $scenarioId: ID!) {
  createScenarioLocation(
    scenarioLocationInput: $scenarioLocationInput
    scenarioId: $scenarioId
  ) {
    errors
    scenarioLocation {
      ...ScenarioLocationOfScenario
    }
  }
}
    ${ScenarioLocationOfScenarioFragmentDoc}`;
export type CreateScenarioLocationMutationFn = Apollo.MutationFunction<CreateScenarioLocationMutation, CreateScenarioLocationMutationVariables>;

/**
 * __useCreateScenarioLocationMutation__
 *
 * To run a mutation, you first call `useCreateScenarioLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScenarioLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScenarioLocationMutation, { data, loading, error }] = useCreateScenarioLocationMutation({
 *   variables: {
 *      scenarioLocationInput: // value for 'scenarioLocationInput'
 *      scenarioId: // value for 'scenarioId'
 *   },
 * });
 */
export function useCreateScenarioLocationMutation(baseOptions?: Apollo.MutationHookOptions<CreateScenarioLocationMutation, CreateScenarioLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScenarioLocationMutation, CreateScenarioLocationMutationVariables>(CreateScenarioLocationDocument, options);
      }
export type CreateScenarioLocationMutationHookResult = ReturnType<typeof useCreateScenarioLocationMutation>;
export type CreateScenarioLocationMutationResult = Apollo.MutationResult<CreateScenarioLocationMutation>;
export type CreateScenarioLocationMutationOptions = Apollo.BaseMutationOptions<CreateScenarioLocationMutation, CreateScenarioLocationMutationVariables>;
export const UpdateScenarioLocationDocument = gql`
    mutation updateScenarioLocation($scenarioLocationId: ID!, $updateInput: ScenarioLocationInput!) {
  updateScenarioLocation(
    scenarioLocationId: $scenarioLocationId
    updateInput: $updateInput
  ) {
    errors
    scenarioLocation {
      ...ScenarioLocation
    }
  }
}
    ${ScenarioLocationFragmentDoc}`;
export type UpdateScenarioLocationMutationFn = Apollo.MutationFunction<UpdateScenarioLocationMutation, UpdateScenarioLocationMutationVariables>;

/**
 * __useUpdateScenarioLocationMutation__
 *
 * To run a mutation, you first call `useUpdateScenarioLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScenarioLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScenarioLocationMutation, { data, loading, error }] = useUpdateScenarioLocationMutation({
 *   variables: {
 *      scenarioLocationId: // value for 'scenarioLocationId'
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateScenarioLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScenarioLocationMutation, UpdateScenarioLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScenarioLocationMutation, UpdateScenarioLocationMutationVariables>(UpdateScenarioLocationDocument, options);
      }
export type UpdateScenarioLocationMutationHookResult = ReturnType<typeof useUpdateScenarioLocationMutation>;
export type UpdateScenarioLocationMutationResult = Apollo.MutationResult<UpdateScenarioLocationMutation>;
export type UpdateScenarioLocationMutationOptions = Apollo.BaseMutationOptions<UpdateScenarioLocationMutation, UpdateScenarioLocationMutationVariables>;
export const ArchiveScenarioLocationDocument = gql`
    mutation archiveScenarioLocation($scenarioLocationId: ID!) {
  archiveScenarioLocation(scenarioLocationId: $scenarioLocationId) {
    errors
    scenarioLocation {
      ...ScenarioLocation
    }
  }
}
    ${ScenarioLocationFragmentDoc}`;
export type ArchiveScenarioLocationMutationFn = Apollo.MutationFunction<ArchiveScenarioLocationMutation, ArchiveScenarioLocationMutationVariables>;

/**
 * __useArchiveScenarioLocationMutation__
 *
 * To run a mutation, you first call `useArchiveScenarioLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveScenarioLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveScenarioLocationMutation, { data, loading, error }] = useArchiveScenarioLocationMutation({
 *   variables: {
 *      scenarioLocationId: // value for 'scenarioLocationId'
 *   },
 * });
 */
export function useArchiveScenarioLocationMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveScenarioLocationMutation, ArchiveScenarioLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveScenarioLocationMutation, ArchiveScenarioLocationMutationVariables>(ArchiveScenarioLocationDocument, options);
      }
export type ArchiveScenarioLocationMutationHookResult = ReturnType<typeof useArchiveScenarioLocationMutation>;
export type ArchiveScenarioLocationMutationResult = Apollo.MutationResult<ArchiveScenarioLocationMutation>;
export type ArchiveScenarioLocationMutationOptions = Apollo.BaseMutationOptions<ArchiveScenarioLocationMutation, ArchiveScenarioLocationMutationVariables>;
export const UpdateTranslationsDocument = gql`
    mutation updateTranslations($archivedTranslationIds: [String!]!, $newTranslations: [TranslationCreateInput!]!, $updatedTranslations: [TranslationUpdateInput!]!) {
  updateTranslations(
    archivedTranslationIds: $archivedTranslationIds
    newTranslations: $newTranslations
    updatedTranslations: $updatedTranslations
  ) {
    ...Translation
  }
}
    ${TranslationFragmentDoc}`;
export type UpdateTranslationsMutationFn = Apollo.MutationFunction<UpdateTranslationsMutation, UpdateTranslationsMutationVariables>;

/**
 * __useUpdateTranslationsMutation__
 *
 * To run a mutation, you first call `useUpdateTranslationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTranslationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTranslationsMutation, { data, loading, error }] = useUpdateTranslationsMutation({
 *   variables: {
 *      archivedTranslationIds: // value for 'archivedTranslationIds'
 *      newTranslations: // value for 'newTranslations'
 *      updatedTranslations: // value for 'updatedTranslations'
 *   },
 * });
 */
export function useUpdateTranslationsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTranslationsMutation, UpdateTranslationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTranslationsMutation, UpdateTranslationsMutationVariables>(UpdateTranslationsDocument, options);
      }
export type UpdateTranslationsMutationHookResult = ReturnType<typeof useUpdateTranslationsMutation>;
export type UpdateTranslationsMutationResult = Apollo.MutationResult<UpdateTranslationsMutation>;
export type UpdateTranslationsMutationOptions = Apollo.BaseMutationOptions<UpdateTranslationsMutation, UpdateTranslationsMutationVariables>;
export const GetBackpackItemsOfScenarioDocument = gql`
    query GetBackpackItemsOfScenario($scenarioId: ID!) {
  backpackItemsOfScenario(scenarioId: $scenarioId) {
    ...BackpackItem
  }
}
    ${BackpackItemFragmentDoc}`;

/**
 * __useGetBackpackItemsOfScenarioQuery__
 *
 * To run a query within a React component, call `useGetBackpackItemsOfScenarioQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBackpackItemsOfScenarioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBackpackItemsOfScenarioQuery({
 *   variables: {
 *      scenarioId: // value for 'scenarioId'
 *   },
 * });
 */
export function useGetBackpackItemsOfScenarioQuery(baseOptions: Apollo.QueryHookOptions<GetBackpackItemsOfScenarioQuery, GetBackpackItemsOfScenarioQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBackpackItemsOfScenarioQuery, GetBackpackItemsOfScenarioQueryVariables>(GetBackpackItemsOfScenarioDocument, options);
      }
export function useGetBackpackItemsOfScenarioLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBackpackItemsOfScenarioQuery, GetBackpackItemsOfScenarioQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBackpackItemsOfScenarioQuery, GetBackpackItemsOfScenarioQueryVariables>(GetBackpackItemsOfScenarioDocument, options);
        }
export type GetBackpackItemsOfScenarioQueryHookResult = ReturnType<typeof useGetBackpackItemsOfScenarioQuery>;
export type GetBackpackItemsOfScenarioLazyQueryHookResult = ReturnType<typeof useGetBackpackItemsOfScenarioLazyQuery>;
export type GetBackpackItemsOfScenarioQueryResult = Apollo.QueryResult<GetBackpackItemsOfScenarioQuery, GetBackpackItemsOfScenarioQueryVariables>;
export const GetAllCitiesDocument = gql`
    query GetAllCities {
  cities {
    _id
    description
    imageKey
    name
  }
}
    `;

/**
 * __useGetAllCitiesQuery__
 *
 * To run a query within a React component, call `useGetAllCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCitiesQuery, GetAllCitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCitiesQuery, GetAllCitiesQueryVariables>(GetAllCitiesDocument, options);
      }
export function useGetAllCitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCitiesQuery, GetAllCitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCitiesQuery, GetAllCitiesQueryVariables>(GetAllCitiesDocument, options);
        }
export type GetAllCitiesQueryHookResult = ReturnType<typeof useGetAllCitiesQuery>;
export type GetAllCitiesLazyQueryHookResult = ReturnType<typeof useGetAllCitiesLazyQuery>;
export type GetAllCitiesQueryResult = Apollo.QueryResult<GetAllCitiesQuery, GetAllCitiesQueryVariables>;
export const GetCollectionsDocument = gql`
    query GetCollections {
  collections {
    ...Collection
  }
}
    ${CollectionFragmentDoc}`;

/**
 * __useGetCollectionsQuery__
 *
 * To run a query within a React component, call `useGetCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCollectionsQuery(baseOptions?: Apollo.QueryHookOptions<GetCollectionsQuery, GetCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionsQuery, GetCollectionsQueryVariables>(GetCollectionsDocument, options);
      }
export function useGetCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionsQuery, GetCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionsQuery, GetCollectionsQueryVariables>(GetCollectionsDocument, options);
        }
export type GetCollectionsQueryHookResult = ReturnType<typeof useGetCollectionsQuery>;
export type GetCollectionsLazyQueryHookResult = ReturnType<typeof useGetCollectionsLazyQuery>;
export type GetCollectionsQueryResult = Apollo.QueryResult<GetCollectionsQuery, GetCollectionsQueryVariables>;
export const GetCollectionDocument = gql`
    query GetCollection($collectionId: ID!) {
  collection(collectionId: $collectionId) {
    ...Collection
  }
}
    ${CollectionFragmentDoc}`;

/**
 * __useGetCollectionQuery__
 *
 * To run a query within a React component, call `useGetCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGetCollectionQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionQuery, GetCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionQuery, GetCollectionQueryVariables>(GetCollectionDocument, options);
      }
export function useGetCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionQuery, GetCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionQuery, GetCollectionQueryVariables>(GetCollectionDocument, options);
        }
export type GetCollectionQueryHookResult = ReturnType<typeof useGetCollectionQuery>;
export type GetCollectionLazyQueryHookResult = ReturnType<typeof useGetCollectionLazyQuery>;
export type GetCollectionQueryResult = Apollo.QueryResult<GetCollectionQuery, GetCollectionQueryVariables>;
export const GetItemsOfCollectionDocument = gql`
    query GetItemsOfCollection($collectionId: ID!) {
  itemsOfCollection(collectionId: $collectionId) {
    ...CollectionItem
  }
}
    ${CollectionItemFragmentDoc}`;

/**
 * __useGetItemsOfCollectionQuery__
 *
 * To run a query within a React component, call `useGetItemsOfCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItemsOfCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItemsOfCollectionQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGetItemsOfCollectionQuery(baseOptions: Apollo.QueryHookOptions<GetItemsOfCollectionQuery, GetItemsOfCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetItemsOfCollectionQuery, GetItemsOfCollectionQueryVariables>(GetItemsOfCollectionDocument, options);
      }
export function useGetItemsOfCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetItemsOfCollectionQuery, GetItemsOfCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetItemsOfCollectionQuery, GetItemsOfCollectionQueryVariables>(GetItemsOfCollectionDocument, options);
        }
export type GetItemsOfCollectionQueryHookResult = ReturnType<typeof useGetItemsOfCollectionQuery>;
export type GetItemsOfCollectionLazyQueryHookResult = ReturnType<typeof useGetItemsOfCollectionLazyQuery>;
export type GetItemsOfCollectionQueryResult = Apollo.QueryResult<GetItemsOfCollectionQuery, GetItemsOfCollectionQueryVariables>;
export const GetDiscountsDocument = gql`
    query GET_DISCOUNTS {
  discounts {
    _id
    amount
    restrictedUserIds
    code
    state
  }
}
    `;

/**
 * __useGetDiscountsQuery__
 *
 * To run a query within a React component, call `useGetDiscountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDiscountsQuery(baseOptions?: Apollo.QueryHookOptions<GetDiscountsQuery, GetDiscountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDiscountsQuery, GetDiscountsQueryVariables>(GetDiscountsDocument, options);
      }
export function useGetDiscountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiscountsQuery, GetDiscountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDiscountsQuery, GetDiscountsQueryVariables>(GetDiscountsDocument, options);
        }
export type GetDiscountsQueryHookResult = ReturnType<typeof useGetDiscountsQuery>;
export type GetDiscountsLazyQueryHookResult = ReturnType<typeof useGetDiscountsLazyQuery>;
export type GetDiscountsQueryResult = Apollo.QueryResult<GetDiscountsQuery, GetDiscountsQueryVariables>;
export const GetGamesDocument = gql`
    query GetGames {
  games {
    _id
    completedAt
    createdAt
    isInDemoMode
    joinCode
    scenario {
      imageKey
      title
    }
    startedAt
    state
    transaction {
      origin
      priceDetails {
        total
        paid
        discount
      }
    }
    user {
      email
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useGetGamesQuery__
 *
 * To run a query within a React component, call `useGetGamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGamesQuery(baseOptions?: Apollo.QueryHookOptions<GetGamesQuery, GetGamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGamesQuery, GetGamesQueryVariables>(GetGamesDocument, options);
      }
export function useGetGamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGamesQuery, GetGamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGamesQuery, GetGamesQueryVariables>(GetGamesDocument, options);
        }
export type GetGamesQueryHookResult = ReturnType<typeof useGetGamesQuery>;
export type GetGamesLazyQueryHookResult = ReturnType<typeof useGetGamesLazyQuery>;
export type GetGamesQueryResult = Apollo.QueryResult<GetGamesQuery, GetGamesQueryVariables>;
export const GetGameDocument = gql`
    query GetGame($gameId: ID!) {
  game(gameId: $gameId) {
    ...Game
  }
}
    ${GameFragmentDoc}`;

/**
 * __useGetGameQuery__
 *
 * To run a query within a React component, call `useGetGameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGameQuery({
 *   variables: {
 *      gameId: // value for 'gameId'
 *   },
 * });
 */
export function useGetGameQuery(baseOptions: Apollo.QueryHookOptions<GetGameQuery, GetGameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGameQuery, GetGameQueryVariables>(GetGameDocument, options);
      }
export function useGetGameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGameQuery, GetGameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGameQuery, GetGameQueryVariables>(GetGameDocument, options);
        }
export type GetGameQueryHookResult = ReturnType<typeof useGetGameQuery>;
export type GetGameLazyQueryHookResult = ReturnType<typeof useGetGameLazyQuery>;
export type GetGameQueryResult = Apollo.QueryResult<GetGameQuery, GetGameQueryVariables>;
export const GetImageTranslationsDocument = gql`
    query GetImageTranslations {
  imageTranslations {
    ...ImageTranslation
  }
}
    ${ImageTranslationFragmentDoc}`;

/**
 * __useGetImageTranslationsQuery__
 *
 * To run a query within a React component, call `useGetImageTranslationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImageTranslationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImageTranslationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetImageTranslationsQuery(baseOptions?: Apollo.QueryHookOptions<GetImageTranslationsQuery, GetImageTranslationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetImageTranslationsQuery, GetImageTranslationsQueryVariables>(GetImageTranslationsDocument, options);
      }
export function useGetImageTranslationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetImageTranslationsQuery, GetImageTranslationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetImageTranslationsQuery, GetImageTranslationsQueryVariables>(GetImageTranslationsDocument, options);
        }
export type GetImageTranslationsQueryHookResult = ReturnType<typeof useGetImageTranslationsQuery>;
export type GetImageTranslationsLazyQueryHookResult = ReturnType<typeof useGetImageTranslationsLazyQuery>;
export type GetImageTranslationsQueryResult = Apollo.QueryResult<GetImageTranslationsQuery, GetImageTranslationsQueryVariables>;
export const GetScenarioLocationPuzzlesDocument = gql`
    query getScenarioLocationPuzzles($scenarioLocationId: ID!) {
  scenarioLocationPuzzles(scenarioLocationId: $scenarioLocationId) {
    ...Puzzle
  }
}
    ${PuzzleFragmentDoc}`;

/**
 * __useGetScenarioLocationPuzzlesQuery__
 *
 * To run a query within a React component, call `useGetScenarioLocationPuzzlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScenarioLocationPuzzlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScenarioLocationPuzzlesQuery({
 *   variables: {
 *      scenarioLocationId: // value for 'scenarioLocationId'
 *   },
 * });
 */
export function useGetScenarioLocationPuzzlesQuery(baseOptions: Apollo.QueryHookOptions<GetScenarioLocationPuzzlesQuery, GetScenarioLocationPuzzlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScenarioLocationPuzzlesQuery, GetScenarioLocationPuzzlesQueryVariables>(GetScenarioLocationPuzzlesDocument, options);
      }
export function useGetScenarioLocationPuzzlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScenarioLocationPuzzlesQuery, GetScenarioLocationPuzzlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScenarioLocationPuzzlesQuery, GetScenarioLocationPuzzlesQueryVariables>(GetScenarioLocationPuzzlesDocument, options);
        }
export type GetScenarioLocationPuzzlesQueryHookResult = ReturnType<typeof useGetScenarioLocationPuzzlesQuery>;
export type GetScenarioLocationPuzzlesLazyQueryHookResult = ReturnType<typeof useGetScenarioLocationPuzzlesLazyQuery>;
export type GetScenarioLocationPuzzlesQueryResult = Apollo.QueryResult<GetScenarioLocationPuzzlesQuery, GetScenarioLocationPuzzlesQueryVariables>;
export const GetScenariosDocument = gql`
    query GET_SCENARIOS {
  scenarios {
    _id
    imageKey
    price
    state
    title
  }
}
    `;

/**
 * __useGetScenariosQuery__
 *
 * To run a query within a React component, call `useGetScenariosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScenariosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScenariosQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetScenariosQuery(baseOptions?: Apollo.QueryHookOptions<GetScenariosQuery, GetScenariosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScenariosQuery, GetScenariosQueryVariables>(GetScenariosDocument, options);
      }
export function useGetScenariosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScenariosQuery, GetScenariosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScenariosQuery, GetScenariosQueryVariables>(GetScenariosDocument, options);
        }
export type GetScenariosQueryHookResult = ReturnType<typeof useGetScenariosQuery>;
export type GetScenariosLazyQueryHookResult = ReturnType<typeof useGetScenariosLazyQuery>;
export type GetScenariosQueryResult = Apollo.QueryResult<GetScenariosQuery, GetScenariosQueryVariables>;
export const GetScenarioDetailsDocument = gql`
    query GET_SCENARIO_DETAILS($scenarioId: ID!) {
  scenario(scenarioId: $scenarioId) {
    ...Scenario
    landmarks {
      ...Landmark
    }
    scenarioLocations {
      ...ScenarioLocationOfScenario
    }
  }
}
    ${ScenarioFragmentDoc}
${LandmarkFragmentDoc}
${ScenarioLocationOfScenarioFragmentDoc}`;

/**
 * __useGetScenarioDetailsQuery__
 *
 * To run a query within a React component, call `useGetScenarioDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScenarioDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScenarioDetailsQuery({
 *   variables: {
 *      scenarioId: // value for 'scenarioId'
 *   },
 * });
 */
export function useGetScenarioDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetScenarioDetailsQuery, GetScenarioDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScenarioDetailsQuery, GetScenarioDetailsQueryVariables>(GetScenarioDetailsDocument, options);
      }
export function useGetScenarioDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScenarioDetailsQuery, GetScenarioDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScenarioDetailsQuery, GetScenarioDetailsQueryVariables>(GetScenarioDetailsDocument, options);
        }
export type GetScenarioDetailsQueryHookResult = ReturnType<typeof useGetScenarioDetailsQuery>;
export type GetScenarioDetailsLazyQueryHookResult = ReturnType<typeof useGetScenarioDetailsLazyQuery>;
export type GetScenarioDetailsQueryResult = Apollo.QueryResult<GetScenarioDetailsQuery, GetScenarioDetailsQueryVariables>;
export const GetScenarioLocationDetailsDocument = gql`
    query GET_SCENARIO_LOCATION_DETAILS($scenarioLocationId: ID!) {
  scenarioLocation(scenarioLocationId: $scenarioLocationId) {
    ...ScenarioLocation
    puzzles {
      ...Puzzle
    }
    sameScenarioLocations {
      _id
      title
    }
  }
}
    ${ScenarioLocationFragmentDoc}
${PuzzleFragmentDoc}`;

/**
 * __useGetScenarioLocationDetailsQuery__
 *
 * To run a query within a React component, call `useGetScenarioLocationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScenarioLocationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScenarioLocationDetailsQuery({
 *   variables: {
 *      scenarioLocationId: // value for 'scenarioLocationId'
 *   },
 * });
 */
export function useGetScenarioLocationDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetScenarioLocationDetailsQuery, GetScenarioLocationDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScenarioLocationDetailsQuery, GetScenarioLocationDetailsQueryVariables>(GetScenarioLocationDetailsDocument, options);
      }
export function useGetScenarioLocationDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScenarioLocationDetailsQuery, GetScenarioLocationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScenarioLocationDetailsQuery, GetScenarioLocationDetailsQueryVariables>(GetScenarioLocationDetailsDocument, options);
        }
export type GetScenarioLocationDetailsQueryHookResult = ReturnType<typeof useGetScenarioLocationDetailsQuery>;
export type GetScenarioLocationDetailsLazyQueryHookResult = ReturnType<typeof useGetScenarioLocationDetailsLazyQuery>;
export type GetScenarioLocationDetailsQueryResult = Apollo.QueryResult<GetScenarioLocationDetailsQuery, GetScenarioLocationDetailsQueryVariables>;
export const GetTranslationsDocument = gql`
    query GetTranslations {
  translations {
    ...Translation
  }
}
    ${TranslationFragmentDoc}`;

/**
 * __useGetTranslationsQuery__
 *
 * To run a query within a React component, call `useGetTranslationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranslationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranslationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTranslationsQuery(baseOptions?: Apollo.QueryHookOptions<GetTranslationsQuery, GetTranslationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTranslationsQuery, GetTranslationsQueryVariables>(GetTranslationsDocument, options);
      }
export function useGetTranslationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTranslationsQuery, GetTranslationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTranslationsQuery, GetTranslationsQueryVariables>(GetTranslationsDocument, options);
        }
export type GetTranslationsQueryHookResult = ReturnType<typeof useGetTranslationsQuery>;
export type GetTranslationsLazyQueryHookResult = ReturnType<typeof useGetTranslationsLazyQuery>;
export type GetTranslationsQueryResult = Apollo.QueryResult<GetTranslationsQuery, GetTranslationsQueryVariables>;
export const GetUsersDocument = gql`
    query GET_USERS {
  users {
    _id
    deviceId
    email
    firstName
    lastName
    stripeCustomerId
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;